// src/screens/FormDetailScreen.js - VERSÃO COMPLETAMENTE CORRIGIDA + STREAMING
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { LogBox } from 'react-native';
import { getAvaliadorById } from '../data/EstruturaOrganizacional';

LogBox.ignoreAllLogs();

import {
  View,
  StyleSheet,
  ScrollView,
  findNodeHandle,
  UIManager,
  Modal,
  TouchableOpacity,
  Alert,
  Linking,
  Platform,
} from 'react-native';
import {
  Appbar,
  Card,
  Title,
  Paragraph,
  Button,
  RadioButton,
  TextInput,
  Text,
  ProgressBar,
  Chip,
  Badge,
  IconButton,
  ActivityIndicator,
} from 'react-native-paper';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Share, Clipboard } from 'react-native';
import {
  createStream,
  updateStreamDebounced,
  checkActiveStream,
  deactivateStream,
} from '../lib/api';
import { AVAQualisTheme } from '../theme/theme';
import { styles } from './FormDetailScreen.css';
import { getFormData, isCustomForm, generateFormDataFromRequirements } from '../data/FormsData';
import AttachmentComponent from '../components/AttachmentComponent';
import StorageManager from '../utils/StorageManager';
import { getLevelEmoji, getLevelDescription } from '../data/EstruturaOrganizacional';
import AuthService from '../services/authService';

// CONFIGURAÇÕES DE PERFORMANCE ULTRA OTIMIZADAS
const AUTO_SAVE_DELAY = 10000; // 10 segundos para auto-save (aumentado)
const SAVE_THROTTLE = 8000; // 8 segundos entre saves
const MAX_AUTO_SAVES_PER_MINUTE = 3; // Máximo 3 auto-saves por minuto (reduzido)
const DEBOUNCE_DELAY = 3000; // 3 segundos para debounce

// Necessário para Android funcionar com measureLayout
if (UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

// Componente Dialog Personalizado
const CustomDialog = React.memo(({ visible, onDismiss, title, message, actions, children }) => {
  const modalContent = useMemo(
    () => (
      <Modal visible={visible} transparent={true} animationType="fade" onRequestClose={onDismiss}>
        <TouchableOpacity style={styles.modalOverlay} activeOpacity={1} onPress={onDismiss}>
          <TouchableOpacity style={styles.dialogContainer} activeOpacity={1} onPress={() => {}}>
            <View style={styles.dialogHeader}>
              <Text style={styles.dialogTitle}>{title}</Text>
            </View>

            <View style={styles.dialogContent}>
              {children || <Text style={styles.dialogMessage}>{message}</Text>}
            </View>

            <View style={styles.dialogActions}>
              {actions.map((action, index) => (
                <TouchableOpacity
                  key={index}
                  style={[
                    styles.dialogButton,
                    index === actions.length - 1
                      ? styles.dialogButtonPrimary
                      : styles.dialogButtonSecondary,
                  ]}
                  onPress={() => {
                    action.action();
                    onDismiss();
                  }}
                >
                  <Text
                    style={[
                      styles.dialogButtonText,
                      index === actions.length - 1
                        ? styles.dialogButtonTextPrimary
                        : styles.dialogButtonTextSecondary,
                    ]}
                  >
                    {action.text}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </TouchableOpacity>
        </TouchableOpacity>
      </Modal>
    ),
    [visible, title, message, actions, children, onDismiss]
  );

  return modalContent;
});

export default function FormDetailScreen({ form, onBack, onViewResponses, onFormUpdated }) {
  // ADICIONAR ESTE LOG AQUI - DENTRO DO COMPONENTE
  console.log('🎯 FormDetailScreen: Props recebidas:', {
    formId: form?.id,
    isValidationMode: form?.isValidationMode,
    hasExistingResponse: !!form?.existingResponse,
    answersCount: form?.existingAnswers ? Object.keys(form.existingAnswers).length : 0,
    attachmentsCount: form?.existingAttachments ? Object.keys(form.existingAttachments).length : 0,
  });
  if (!form) {
    console.error('❌ FormDetailScreen: Formulário não fornecido!');
    return (
      <View style={styles.container}>
        <Appbar.Header style={styles.appbar}>
          <Appbar.BackAction
            onPress={() => {
              console.log('🔙 Voltando por erro de formulário não fornecido');
              if (typeof onBack === 'function') {
                onBack();
              }
            }}
            color={AVAQualisTheme.colors.onPrimary}
          />
          <Appbar.Content title="❌ Erro" titleStyle={styles.appbarTitle} />
        </Appbar.Header>
        <View style={styles.loadingContainer}>
          <Text style={styles.loadingText}>❌ Formulário não encontrado</Text>
          <Button
            mode="contained"
            onPress={() => {
              if (typeof onBack === 'function') {
                onBack();
              }
            }}
            style={{ marginTop: 16 }}
            icon="arrow-left"
          >
            🔙 Voltar
          </Button>
        </View>
      </View>
    );
  }

  console.log('🎯 FormDetailScreen: Inicializando LIMPO com formulário:', {
    id: form.id,
    title: form.title,
    requirementsCount: form.requirements?.length || 0,
    totalQuestions: form.totalQuestions,
    isEditingFromResults: form.isEditingFromResults,
    currentProgress: form.currentProgress,
    hasExistingResponses: form.hasExistingResponses,
  });

  // Estados para respostas e interações
  const [answers, setAnswers] = useState({});
  const [findings, setFindings] = useState({});
  const [savedFindings, setSavedFindings] = useState({});
  const [notApplicableReasons, setNotApplicableReasons] = useState({});
  const [attachments, setAttachments] = useState({});
  const [attachmentLocalData, setAttachmentLocalData] = useState({});
  const [existingResponse, setExistingResponse] = useState(null);

  // Estados para UI
  const [dialogVisible, setDialogVisible] = useState(false);
  const [notApplicableDialogVisible, setNotApplicableDialogVisible] = useState(false);

  // ✅ ADICIONAR ESTE NOVO ESTADO:
  const [savingProgressDialog, setSavingProgressDialog] = useState(false);
  const [savingCountdown, setSavingCountdown] = useState(20);

  const [tempNotApplicableText, setTempNotApplicableText] = useState('');
  const [currentQuestionId, setCurrentQuestionId] = useState(null);
  const [activeEditingQuestion, setActiveEditingQuestion] = useState(null);
  const [dialogContent, setDialogContent] = useState({
    title: '',
    message: '',
    actions: [],
  });
  const [expandedSections, setExpandedSections] = useState({});

  // Estados para carregamento do formulário
  const [formData, setFormData] = useState(null);
  const [loadingFormData, setLoadingFormData] = useState(true);
  const [formLoadError, setFormLoadError] = useState(null);

  // CORREÇÃO CRÍTICA: Estados controlados para salvamento SIMPLIFICADOS
  const [isSaving, setIsSaving] = useState(false);
  const [currentResponseId, setCurrentResponseId] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [lastSaveTime, setLastSaveTime] = useState(0);

  // Estados para streaming
  const [streamActive, setStreamActive] = useState(false);
  const [streamId, setStreamId] = useState(null);
  const [streamLink, setStreamLink] = useState(null);
  const [showStreamDialog, setShowStreamDialog] = useState(false);
  const [streamDialogType, setStreamDialogType] = useState(''); // 'start' ou 'active'

  // Refs
  const questionRefs = useRef([]);
  const scrollRef = useRef(null);
  const responseIdRef = useRef(null);

  // CORREÇÃO CRÍTICA: Refs para controle ULTRA SIMPLIFICADOS
  const autoSaveTimeoutRef = useRef(null);
  const lastDataSnapshotRef = useRef('');
  const autoSaveCountRef = useRef(0);
  const lastAutoSaveResetRef = useRef(Date.now());
  const isMountedRef = useRef(true);
  const saveInProgressRef = useRef(false);
  const initializationCompleteRef = useRef(false);

  const isEditingFromResults = form?.isEditingFromResults || false;

  // OTIMIZAÇÃO: Memoizar avaliador atual

  // Modifique o useMemo do currentAvaliador:
  const currentAvaliador = useMemo(() => {
    if (isEditingFromResults && existingResponse?.avaliador) {
      console.log('📝 FormDetailScreen: Mantendo avaliador original da resposta existente');
      return existingResponse.avaliador;
    }

    const avaliadorLogado = AuthService.getAvaliador();
    if (avaliadorLogado && avaliadorLogado.id && avaliadorLogado.id !== 'visitor') {
      console.log('👤 FormDetailScreen: Buscando dados completos do avaliador logado');

      // CORREÇÃO: Buscar dados completos do avaliador
      const avaliadorCompleto = getAvaliadorById(avaliadorLogado.id);

      if (avaliadorCompleto) {
        console.log('✅ Dados completos do avaliador:', avaliadorCompleto);
        return {
          id: avaliadorCompleto.id,
          nome: avaliadorCompleto.nome,
          login: avaliadorCompleto.login, // Login correto!
          level: avaliadorCompleto.level,
        };
      }

      // Fallback se não encontrar
      return {
        id: avaliadorLogado.id,
        nome: avaliadorLogado.nome,
        login: avaliadorLogado.login || avaliadorLogado.email || 'sem_email@ebserh.gov.br',
        level: avaliadorLogado.level || 'membro',
      };
    }

    console.error('⚠️ FormDetailScreen: ERRO - Nenhum avaliador válido encontrado! Usando padrão.');
    return {
      id: 'av00',
      nome: 'Usuário Não Identificado',
      login: 'sem_email@ebserh.gov.br',
      level: 'membro',
    };
  }, [isEditingFromResults, existingResponse?.avaliador]);

  // OTIMIZAÇÃO: Memoizar a função getAllQuestions
  const getAllQuestions = useCallback(() => {
    if (!formData || !formData.sections) {
      return [];
    }

    const allQuestions = [];
    formData.sections.forEach(section => {
      if (section.questions && Array.isArray(section.questions)) {
        section.questions.forEach(question => {
          // ✅ GARANTIR QUE TODOS OS CAMPOS SEJAM COPIADOS
          allQuestions.push({
            ...question, // Copiar TODOS os campos da questão
            sectionInfo: {
              tipo: section.tipo,
              categoria: section.categoria,
              subcategoria: section.subcategoria,
            },
            // ✅ FORÇAR campos específicos se existirem
            grupoRequisito: question.grupoRequisito || '',
            sugestaoRoteiro: question.sugestaoRoteiro || '',
          });
        });
      }
    });

    // LOG de verificação
    if (allQuestions.length > 0) {
      console.log('✅ getAllQuestions - Primeira questão:', {
        id: allQuestions[0].id,
        grupoRequisito: allQuestions[0].grupoRequisito,
        sugestaoRoteiro: allQuestions[0].sugestaoRoteiro,
      });
    }

    return allQuestions;
  }, [formData]);
  // OTIMIZAÇÃO: Memoizar todas as perguntas
  const allQuestions = useMemo(() => getAllQuestions(), [getAllQuestions]);

  // Verificar stream ativo ao montar
  useEffect(() => {
    if (currentAvaliador && currentAvaliador.id && currentAvaliador.id !== 'visitor') {
      checkActiveStream(form.id, currentAvaliador.id)
        .then(result => {
          if (result.hasActiveStream) {
            setStreamActive(true);
            setStreamId(result.streamId);
            setStreamLink(result.shareLink);
          }
        })
        .catch(error => {
          console.error('Erro ao verificar stream ativo:', error);
        });
    }
  }, [form.id, currentAvaliador]);

  // Função para iniciar stream - VERSÃO MELHORADA
  const startStream = async () => {
    try {
      setShowStreamDialog(false);

      console.log('🎥 Iniciando stream para formulário:', form.id);

      const result = await createStream(form.id, formData.title, currentAvaliador);

      setStreamActive(true);
      setStreamId(result.streamId);
      setStreamLink(result.shareLink);

      console.log('✅ Stream iniciado com sucesso:', result.streamId);

      // Enviar dados iniciais do stream
      await updateStreamInitialData();

      // Mostrar dialog com link
      setStreamDialogType('active');
      setShowStreamDialog(true);
    } catch (error) {
      console.error('❌ Erro ao iniciar stream:', error);
      showDialog(
        '❌ Erro ao Iniciar Stream',
        'Não foi possível iniciar o stream. Verifique sua conexão com a internet e tente novamente.',
        [{ text: 'OK', action: () => setDialogVisible(false) }]
      );
    }
  };

  // Função para parar stream
  const stopStream = async () => {
    try {
      if (streamId) {
        await deactivateStream(streamId);
      }

      setStreamActive(false);
      setStreamId(null);
      setStreamLink(null);
      setShowStreamDialog(false);

      showDialog('🛑 Stream Encerrado', 'O stream foi encerrado com sucesso.', [
        { text: 'OK', action: () => setDialogVisible(false) },
      ]);
    } catch (error) {
      console.error('❌ Erro ao parar stream:', error);
    }
  };

  // Função para compartilhar link do stream
  const shareStreamLink = async () => {
    if (!streamLink) return;

    try {
      if (Platform.OS === 'web') {
        await Clipboard.setString(streamLink);
        Alert.alert(
          '✅ Link Copiado',
          'O link do stream foi copiado para a área de transferência.'
        );
      } else {
        await Share.share({
          message: `🎥 Acompanhe a avaliação em tempo real:\n${streamLink}\n\nEste link expira em 24 horas.`,
          title: 'Link do Stream AVAQualis.com',
          url: streamLink,
        });
      }
    } catch (error) {
      console.error('Erro ao compartilhar:', error);
    }
  };

  // Função para atualizar dados iniciais do stream - VERSÃO CORRIGIDA
  const updateStreamInitialData = async () => {
    if (!streamId || !streamActive) return;

    try {
      console.log('📤 Enviando dados iniciais do stream...');

      // Garantir que temos as questões
      const questionsForStream = allQuestions.map(q => ({
        id: q.id,
        codigo: q.codigo,
        isAnswered: !!answers[q.id],
      }));

      const initialData = {
        currentQuestion: null,
        currentAnswer: '',
        currentFindings: '',
        notApplicableReason: '',
        currentAttachments: [],
        questionStatus: 'selecting',
        progress: {
          answeredCount: responseStats.answeredCount || 0,
          totalQuestions: allQuestions.length,
          percentage: responseStats.completionPercentage || 0,
          completedQuestions: Object.keys(answers),
        },
        allQuestions: questionsForStream,
      };

      console.log('📦 Dados iniciais preparados:', {
        totalQuestions: initialData.allQuestions.length,
        answeredCount: initialData.progress.answeredCount,
      });

      await updateStreamDebounced(streamId, initialData, true);

      console.log('✅ Dados iniciais enviados com sucesso');
    } catch (error) {
      console.error('❌ Erro ao atualizar dados iniciais do stream:', error);
    }
  };

  // Função para atualizar stream quando editar pergunta - VERSÃO CORRIGIDA

  // Função para atualizar stream quando editar pergunta - VERSÃO MELHORADA COM ANEXOS
  const updateStreamForQuestion = async questionId => {
    if (!streamId || !streamActive) return;

    try {
      const question = allQuestions.find(q => q.id === questionId);
      if (!question) {
        console.warn('⚠️ Questão não encontrada:', questionId);
        return;
      }

      console.log('📤 Atualizando stream para questão:', question.codigo);
      console.log('🔍 DEBUG - Campos da questão:', {
        hasGrupoRequisito: !!question.grupoRequisito,
        hasSugestaoRoteiro: !!question.sugestaoRoteiro,
        grupoRequisito: question.grupoRequisito,
        sugestaoRoteiro: question.sugestaoRoteiro,
      });

      // Preparar anexos...
      const questionAttachments = attachments[questionId] || [];
      const streamAttachments = questionAttachments.map(att => {
        let bestUrl = att.url || att.supabaseUrl || att.uri || '';
        if (att.type === 'photo' && att.base64) {
          bestUrl = att.base64;
        }
        return {
          id: att.id || `att-${Date.now()}-${Math.random()}`,
          type: att.type || 'file',
          name: att.name || 'Anexo',
          description: att.description || '',
          validityDate: att.validityDate || null,
          mimeType: att.mimeType || 'application/octet-stream',
          size: att.size || 0,
          url: bestUrl,
          isLocal: att.localOnly || false,
          isSynced: att.synced || false,
          hasBase64: !!att.base64,
          isImage: att.type === 'photo',
          isVideo: att.type === 'video',
          isLink: att.type === 'link',
          isFile: att.type === 'file',
        };
      });

      // Preparar dados da questão COM OS NOVOS CAMPOS
      const updateData = {
        currentQuestion: {
          id: question.id,
          codigo: question.codigo,
          question: question.question || question.text || '',
          premissa: question.premissa || '',
          fontes: question.fontes || '',
          segmento: question.segmento || '',
          grupoRequisito: question.grupoRequisito || '', // ✅ NOVO CAMPO
          sugestaoRoteiro: question.sugestaoRoteiro || '', // ✅ NOVO CAMPO
          isEssential: question.isEssential || false,
          sectionInfo: question.sectionInfo || {
            tipo: '',
            categoria: '',
            subcategoria: '',
          },
        },
        currentAnswer: answers[questionId] || '',
        currentFindings: findings[questionId] || '',
        notApplicableReason: notApplicableReasons[questionId] || '',
        currentAttachments: streamAttachments,
        questionStatus: 'editing',
      };

      console.log('📦 Enviando para stream:', {
        questionId: updateData.currentQuestion.id,
        hasGrupoRequisito: !!updateData.currentQuestion.grupoRequisito,
        hasSugestaoRoteiro: !!updateData.currentQuestion.sugestaoRoteiro,
      });

      await updateStreamDebounced(streamId, updateData, true);

      console.log('✅ Stream atualizado com todos os campos');
    } catch (error) {
      console.error('❌ Erro ao atualizar stream para questão:', error);
    }
  };

  // Função para lidar com foco em questão - VERSÃO MELHORADA
  const handleQuestionFocus = useCallback(
    questionId => {
      if (!streamActive || !streamId) return;

      console.log('👁️ Questão focada:', questionId);

      // Atualizar stream quando focar em uma questão
      updateStreamForQuestion(questionId).catch(error => {
        console.warn('⚠️ Erro ao atualizar stream no foco:', error);
      });

      setActiveEditingQuestion(questionId);
    },
    [streamActive, streamId]
  );

  // CORREÇÃO CRÍTICA: Função para criar snapshot dos dados SIMPLIFICADA
  const createDataSnapshot = useCallback(() => {
    if (!initializationCompleteRef.current) return '';

    try {
      return JSON.stringify({
        answers: Object.keys(answers).length,
        findings: Object.keys(findings).length,
        savedFindings: Object.keys(savedFindings).length,
        notApplicableReasons: Object.keys(notApplicableReasons).length,
        attachments: Object.keys(attachments).length,
        timestamp: Date.now(), // Adicionar timestamp para evitar snapshots idênticos
      });
    } catch (error) {
      console.error('Erro ao criar snapshot:', error);
      return '';
    }
  }, [answers, findings, savedFindings, notApplicableReasons, attachments]);

  // CORREÇÃO CRÍTICA: Auto-save COMPLETAMENTE REESCRITO SEM LOOPS
  const scheduleAutoSave = useCallback(() => {
    // MÚLTIPLAS VERIFICAÇÕES PARA EVITAR LOOPS
    if (!isMountedRef.current || !isInitialized || !initializationCompleteRef.current) {
      return;
    }

    if (saveInProgressRef.current || isSaving) {
      return;
    }

    // Limpar timeout anterior SEMPRE
    if (autoSaveTimeoutRef.current) {
      clearTimeout(autoSaveTimeoutRef.current);
      autoSaveTimeoutRef.current = null;
    }

    // Verificar limite de auto-saves por minuto
    const now = Date.now();
    if (now - lastAutoSaveResetRef.current > 60000) {
      autoSaveCountRef.current = 0;
      lastAutoSaveResetRef.current = now;
    }

    if (autoSaveCountRef.current >= MAX_AUTO_SAVES_PER_MINUTE) {
      console.log('⚠️ Limite de auto-saves atingido, pulando');
      return;
    }

    // Verificar se realmente houve mudanças
    const currentSnapshot = createDataSnapshot();
    if (!currentSnapshot || currentSnapshot === lastDataSnapshotRef.current) {
      return;
    }

    // Verificar throttle
    if (now - lastSaveTime < SAVE_THROTTLE) {
      return;
    }

    // Agendar auto-save COM PROTEÇÃO EXTRA
    autoSaveTimeoutRef.current = setTimeout(() => {
      if (
        isMountedRef.current &&
        !saveInProgressRef.current &&
        isInitialized &&
        initializationCompleteRef.current
      ) {
        performAutoSave();
      }
    }, AUTO_SAVE_DELAY);
  }, [isInitialized, createDataSnapshot, lastSaveTime, isSaving]);

  // CORREÇÃO CRÍTICA: Perform auto-save COMPLETAMENTE REESCRITO
  const performAutoSave = useCallback(async () => {
    // MÚLTIPLAS VERIFICAÇÕES DE SEGURANÇA
    if (!isMountedRef.current || !initializationCompleteRef.current) {
      return;
    }

    if (saveInProgressRef.current || isSaving) {
      return;
    }

    if (!responseIdRef.current || !currentResponseId) {
      return;
    }

    try {
      saveInProgressRef.current = true;
      setIsSaving(true);
      autoSaveCountRef.current++;

      const success = await saveResponseData(false, true);

      if (success && isMountedRef.current) {
        const newSnapshot = createDataSnapshot();
        lastDataSnapshotRef.current = newSnapshot;
        setLastSaveTime(Date.now());
        setHasUnsavedChanges(false);

        console.log(`💾 Auto-save OK (${autoSaveCountRef.current}/${MAX_AUTO_SAVES_PER_MINUTE})`);
      }
    } catch (error) {
      console.error('❌ Erro no auto-save:', error);
    } finally {
      if (isMountedRef.current) {
        setIsSaving(false);
      }
      saveInProgressRef.current = false;
    }
  }, [createDataSnapshot, currentResponseId, isSaving]);

  // OTIMIZAÇÃO: Memoizar cálculo de progresso atual
  const calculateCurrentProgress = useCallback(() => {
    const answeredCount = Object.keys(answers).length;
    const totalQuestions = allQuestions.length;
    const percentage = totalQuestions > 0 ? Math.round((answeredCount / totalQuestions) * 100) : 0;

    return {
      answered: answeredCount,
      total: totalQuestions,
      percentage: percentage,
    };
  }, [answers, allQuestions.length]);

  // OTIMIZAÇÃO: Memoizar estatísticas de respostas
  const responseStats = useMemo(() => {
    const answeredCount = Object.keys(answers).length;
    const completionPercentage = Math.round((answeredCount / allQuestions.length) * 100);
    const progress = answeredCount / allQuestions.length;
    const isComplete = answeredCount === allQuestions.length;

    return {
      answeredCount,
      completionPercentage,
      progress,
      isComplete,
    };
  }, [answers, allQuestions.length]);

  // OTIMIZAÇÃO: Memoizar função de notificação de atualizações
  const notifyFormUpdate = useCallback(
    responseData => {
      if (!responseData || !isMountedRef.current || !initializationCompleteRef.current) return;

      try {
        const progress = calculateCurrentProgress();

        if (onFormUpdated && typeof onFormUpdated === 'function') {
          onFormUpdated({
            ...responseData,
            progress: progress,
            formId: form.id,
            hasChanges: hasUnsavedChanges,
          });
        }
      } catch (error) {
        console.error('❌ Erro ao notificar atualização:', error);
      }
    },
    [onFormUpdated, form.id, calculateCurrentProgress, hasUnsavedChanges]
  );

  // CORREÇÃO: Carregar dados do formulário com melhor tratamento de erros
  // CORREÇÃO: Carregar dados do formulário com melhor tratamento de erros
  const loadFormData = useCallback(async () => {
    try {
      setLoadingFormData(true);
      setFormLoadError(null);

      // ADICIONAR: Verificação de segurança
      if (!form || !form.id) {
        console.error('❌ FormDetailScreen: form ou form.id não definido');
        setFormLoadError('ID do formulário não fornecido');
        setLoadingFormData(false);
        return;
      }

      // ADICIONAR: Se for modo de validação e já tem dados, usar diretamente
      if (form.isValidationMode && form.formData) {
        console.log('✅ Modo validação: usando dados fornecidos diretamente');
        console.log('📋 Dados do formulário em modo validação:', {
          id: form.formData.id,
          title: form.formData.title,
          totalQuestions: form.formData.totalQuestions,
          sectionsCount: form.formData.sections?.length || 0,
          hasExistingResponse: !!form.existingResponse,
          answersCount: Object.keys(form.existingAnswers || {}).length,
        });

        // IMPORTANTE: Garantir que temos sections
        if (!form.formData.sections || form.formData.sections.length === 0) {
          console.warn('⚠️ FormData sem sections, tentando reconstruir...');

          // Tentar reconstruir sections a partir de questions ou requirements
          const questions = form.formData.questions || form.formData.requirements || [];
          const sectionsMap = new Map();

          questions.forEach(q => {
            const sectionKey = `${q.sectionInfo?.tipo || 'Geral'}-${q.sectionInfo?.categoria || 'Geral'}`;
            if (!sectionsMap.has(sectionKey)) {
              sectionsMap.set(sectionKey, {
                id: `section-${sectionsMap.size + 1}`,
                tipo: q.sectionInfo?.tipo || 'Geral',
                categoria: q.sectionInfo?.categoria || 'Geral',
                subcategoria: q.sectionInfo?.subcategoria || '',
                questions: [],
              });
            }

            sectionsMap.get(sectionKey).questions.push({
              id: q.id || q.codigo,
              codigo: q.codigo,
              question: q.question || q.text,
              premissa: q.premissa,
              fontes: q.fontes,
              segmento: q.segmento,
              grupoRequisito: q.grupoRequisito,
              sugestaoRoteiro: q.sugestaoRoteiro,

              isEssential: q.isEssential,
              sectionInfo: q.sectionInfo,
            });
          });

          form.formData.sections = Array.from(sectionsMap.values());
          console.log(`✅ ${form.formData.sections.length} sections reconstruídas`);
        }

        setFormData(form.formData);
        setLoadingFormData(false);
        return;
      }

      // Se não tem formData mas tem ID, buscar normalmente
      console.log('🔄 Carregando dados do formulário:', form.id);

      if (isCustomForm(form.id)) {
        console.log('🎯 Formulário customizado detectado');

        try {
          await StorageManager.initialize();

          const customForms = await StorageManager.loadCustomForms();
          const customForm = customForms.find(f => f.id === form.id);

          if (customForm) {
            console.log('✅ Formulário customizado encontrado');
            const generatedFormData = generateFormDataFromRequirements(customForm);

            if (generatedFormData) {
              setFormData(generatedFormData);
              console.log('✅ Dados do formulário customizado gerados');
            } else {
              throw new Error('Falha ao gerar dados do formulário customizado');
            }
          } else {
            throw new Error('Formulário customizado não encontrado');
          }
        } catch (storageError) {
          console.error('❌ Erro no StorageManager:', storageError);
          throw new Error(`Erro ao acessar armazenamento: ${storageError.message}`);
        }
      } else {
        console.log('📋 Formulário fixo detectado');

        const fixedFormData = getFormData(form.id);
        if (fixedFormData) {
          setFormData(fixedFormData);
          console.log('✅ Dados do formulário fixo carregados');
        } else {
          throw new Error('Formulário fixo não encontrado nos dados padrão');
        }
      }
    } catch (error) {
      console.error('❌ Erro ao carregar dados do formulário:', error);
      setFormLoadError(error.message || 'Erro desconhecido ao carregar formulário');
    } finally {
      if (isMountedRef.current) {
        setLoadingFormData(false);
      }
    }
  }, [form]);

  // EFEITO OTIMIZADO: Carregar dados do formulário APENAS UMA VEZ
  useEffect(() => {
    if (!isMountedRef.current) return;

    console.log('🔄 Efeito de carregamento de dados executado');
    loadFormData();

    // Marcar formulário como baixado de forma assíncrona
    (async () => {
      try {
        await StorageManager.addDownloadedFormId(form.id);
        console.log(`✅ Formulário ${form.id} marcado como baixado`);
      } catch (error) {
        console.error('❌ Erro ao marcar formulário como baixado:', error);
      }
    })();
  }, [form.id]); // IMPORTANTE: Apenas form.id como dependência

  // Gerar ID único para respostas
  const generateUniqueResponseId = useCallback(() => {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substr(2, 9);
    return `${form.id}_${timestamp}_${random}`;
  }, [form.id]);

  // FUNÇÃO COMPLETAMENTE REESCRITA: Carregar resposta existente SEM LOOPS
  // FUNÇÃO COMPLETAMENTE REESCRITA: Carregar resposta existente SEM LOOPS
  const loadExistingResponse = useCallback(async () => {
    if (!isMountedRef.current) return false;

    try {
      // NOVO: Verificar se veio do modo de validação
      if (form.isValidationMode && form.existingResponse) {
        console.log('🔍 Modo de validação detectado, carregando resposta existente...');
        console.log('📊 Dados recebidos:', {
          responseId: form.existingResponse.id,
          avaliadorOriginal: form.originalAvaliador?.nome,
          respostas: Object.keys(form.existingAnswers || {}).length,
          achados: Object.keys(form.existingFindings || {}).length,
          anexos: Object.keys(form.existingAttachments || {}).length,
        });

        const validationResponse = form.existingResponse;
        if (isMountedRef.current) {
          setExistingResponse(validationResponse);
          setCurrentResponseId(validationResponse.id);
          responseIdRef.current = validationResponse.id;

          // CORREÇÃO CRÍTICA: Carregar dados das props do form, não da response
          setAnswers(form.existingAnswers || form.existingResponse.answers || {});
          setFindings(form.existingFindings || form.existingResponse.findings || {});
          setSavedFindings(form.existingSavedFindings || form.existingResponse.savedFindings || {});
          setNotApplicableReasons(
            form.existingNotApplicableReasons || form.existingResponse.notApplicableReasons || {}
          );
          // CORREÇÃO: Carregar anexos preservando base64
          const loadedAttachments = mostRecent.attachments || {};
          setAttachments(loadedAttachments);
          // Verificar integridade dos anexos no modo validação
          console.log('🔍 Verificando anexos no modo validação...');
          Object.keys(loadedAttachments).forEach(questionId => {
            console.log(`Pergunta ${questionId}: ${loadedAttachments[questionId].length} anexo(s)`);
            loadedAttachments[questionId].forEach((att, index) => {
              console.log(
                `  - Anexo ${index + 1}: ${att.name} (${att.hasLocalData ? 'COM' : 'SEM'} dados locais)`
              );
            });
          });
          // IMPORTANTE: Verificar se os anexos têm base64 salvo
          console.log('📎 Verificando anexos carregados...');
          let totalAttachments = 0;
          let attachmentsWithData = 0;

          Object.keys(loadedAttachments).forEach(questionId => {
            loadedAttachments[questionId].forEach(attachment => {
              totalAttachments++;
              if (attachment.base64 || attachment.hasLocalData) {
                attachmentsWithData++;
              }
            });
          });

          console.log(`✅ ${attachmentsWithData}/${totalAttachments} anexos com dados salvos`);

          // Reconstruir dados locais dos anexos
          const localData = {};
          Object.keys(loadedAttachments).forEach(questionId => {
            loadedAttachments[questionId].forEach(attachment => {
              if (attachment.base64 || attachment.localData) {
                localData[attachment.id] = {
                  dataUrl: attachment.base64,
                  ...attachment.localData,
                };
              }
            });
          });
          setAttachmentLocalData(localData);

          console.log('✅ Dados da resposta carregados:', {
            responseId: validationResponse.id,
            avaliador: validationResponse.avaliador?.nome,
            respostasCarregadas: Object.keys(form.existingAnswers || {}).length,
            anexosCarregados: Object.keys(form.existingAttachments || {}).length,
          });

          // Aguardar um tick antes de criar snapshot inicial
          setTimeout(() => {
            if (isMountedRef.current) {
              const initialSnapshot = createDataSnapshot();
              lastDataSnapshotRef.current = initialSnapshot;
              setHasUnsavedChanges(false);
              console.log('✅ Snapshot inicial criado para modo validação');
            }
          }, 1000);
        }

        return true;
      }

      // Código existente para carregar resposta normal...
      console.log('🔍 Carregando resposta existente...');

      const responses = await StorageManager.loadFormResponses();

      const formResponses = responses.filter(
        r => r.formId === form.id && r.avaliador?.id === currentAvaliador.id
      );

      if (formResponses.length > 0) {
        formResponses.sort((a, b) => {
          const dateA = new Date(a.lastModified || a.createdAt);
          const dateB = new Date(b.lastModified || b.createdAt);
          return dateB - dateA;
        });

        const mostRecent = formResponses[0];
        console.log('✅ Resposta existente encontrada:', mostRecent.id);

        if (isMountedRef.current) {
          setExistingResponse(mostRecent);
          setCurrentResponseId(mostRecent.id);
          responseIdRef.current = mostRecent.id;

          // CORREÇÃO CRÍTICA: Carregar dados SEM triggerar auto-save
          setAnswers(mostRecent.answers || {});
          setFindings(mostRecent.findings || {});
          setSavedFindings(mostRecent.savedFindings || {});
          setNotApplicableReasons(mostRecent.notApplicableReasons || {});
          const loadedAttachments = mostRecent.attachments || {};
          setAttachments(loadedAttachments);

          // Reconstruir dados locais dos anexos
          const localData = {};
          Object.keys(loadedAttachments).forEach(questionId => {
            loadedAttachments[questionId].forEach(attachment => {
              if (attachment.base64 || attachment.localData) {
                localData[attachment.id] = {
                  dataUrl: attachment.base64,
                  ...attachment.localData,
                };
              }
            });
          });
          setAttachmentLocalData(localData);
          // Aguardar um tick antes de criar snapshot inicial
          setTimeout(() => {
            if (isMountedRef.current) {
              const initialSnapshot = createDataSnapshot();
              lastDataSnapshotRef.current = initialSnapshot;
              setHasUnsavedChanges(false);
              console.log('✅ Snapshot inicial criado');
            }
          }, 1000);
        }

        // Limpar respostas duplicadas
        if (formResponses.length > 1) {
          const otherResponses = formResponses.slice(1);
          for (const oldResponse of otherResponses) {
            try {
              await StorageManager.removeResponse(oldResponse.id);
              console.log('🗑️ Resposta duplicada removida:', oldResponse.id);
            } catch (removeError) {
              console.error('❌ Erro ao remover resposta antiga:', removeError);
            }
          }
        }
      } else {
        console.log(`ℹ️ Nenhuma resposta existente encontrada, gerando novo ID`);
        const newId = generateUniqueResponseId();

        if (isMountedRef.current) {
          setCurrentResponseId(newId);
          responseIdRef.current = newId;

          setTimeout(() => {
            if (isMountedRef.current) {
              const emptySnapshot = createDataSnapshot();
              lastDataSnapshotRef.current = emptySnapshot;
              setHasUnsavedChanges(false);
              console.log('✅ ID novo criado:', newId);
            }
          }, 1000);
        }
      }

      return true;
    } catch (error) {
      console.error('❌ Erro ao carregar resposta existente:', error);
      const newId = generateUniqueResponseId();

      if (isMountedRef.current) {
        setCurrentResponseId(newId);
        responseIdRef.current = newId;
      }
      return false;
    }
  }, [form, currentAvaliador, generateUniqueResponseId, createDataSnapshot]);

  // EFEITO COMPLETAMENTE REESCRITO: Carregar resposta existente e inicializar SEM LOOPS
  useEffect(() => {
    if (!formData || loadingFormData || !isMountedRef.current) {
      return;
    }

    if (initializationCompleteRef.current) {
      return; // Já inicializado, não fazer novamente
    }

    console.log('🔄 Iniciando processo de inicialização...');

    loadExistingResponse()
      .then(() => {
        if (isMountedRef.current) {
          questionRefs.current = new Array(allQuestions.length).fill(null);

          const initialExpanded = {};
          formData.sections.forEach(section => {
            initialExpanded[section.id] = true;
          });
          setExpandedSections(initialExpanded);

          // IMPORTANTE: Aguardar antes de marcar como inicializado
          setTimeout(() => {
            if (isMountedRef.current) {
              setIsInitialized(true);
              initializationCompleteRef.current = true;
              console.log('✅ FormDetailScreen COMPLETAMENTE inicializado');
            }
          }, 1500);
        }
      })
      .catch(error => {
        console.error('❌ Erro na inicialização:', error);
        // Tentar continuar mesmo com erro
        if (isMountedRef.current) {
          setIsInitialized(true);
          initializationCompleteRef.current = true;
        }
      });
  }, [formData, loadingFormData, allQuestions.length]); // Dependências mínimas

  // EFEITO CRÍTICO: Detectar mudanças APENAS APÓS INICIALIZAÇÃO COMPLETA
  useEffect(() => {
    if (!isInitialized || !initializationCompleteRef.current || !isMountedRef.current) {
      return;
    }

    // Aguardar um pouco antes de verificar mudanças para evitar false positives
    const timeoutId = setTimeout(() => {
      if (!isMountedRef.current || !initializationCompleteRef.current) return;

      const currentSnapshot = createDataSnapshot();
      const hasChanges = currentSnapshot !== lastDataSnapshotRef.current;

      if (hasChanges !== hasUnsavedChanges) {
        setHasUnsavedChanges(hasChanges);

        if (hasChanges && !saveInProgressRef.current && isMountedRef.current) {
          scheduleAutoSave();
        }
      }
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(timeoutId);
  }, [
    answers,
    findings,
    savedFindings,
    notApplicableReasons,
    attachments,
    isInitialized,
    hasUnsavedChanges,
    scheduleAutoSave,
    createDataSnapshot,
  ]);

  // EFEITO DE CLEANUP: Limpar timeouts ao desmontar
  useEffect(() => {
    return () => {
      console.log('🧹 FormDetailScreen: Limpando refs e timeouts...');
      isMountedRef.current = false;
      initializationCompleteRef.current = false;

      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current);
        autoSaveTimeoutRef.current = null;
      }
    };
  }, []);

  // Função para lidar com mudanças nos anexos - VERSÃO CORRIGIDA COM STREAM
  const handleAttachmentsChange = useCallback(
    (questionId, newAttachments) => {
      console.log('📎 Atualizando anexos para pergunta:', questionId);

      if (isMountedRef.current && initializationCompleteRef.current) {
        setAttachments(prev => ({
          ...prev,
          [questionId]: newAttachments,
        }));

        // SALVAMENTO LOCAL IMEDIATO DOS ANEXOS
        setTimeout(async () => {
          if (!isMountedRef.current) return;

          const updatedAttachments = { ...attachments, [questionId]: newAttachments };
          const currentProgress = calculateCurrentProgress();

          const responseToSave = {
            id: responseIdRef.current || currentResponseId,
            formId: form.id,
            formTitle: formData.title,
            answers: answers,
            findings: findings,
            savedFindings: savedFindings,
            notApplicableReasons: notApplicableReasons,
            attachments: updatedAttachments,
            createdAt: existingResponse?.createdAt || new Date().toISOString(),
            lastModified: new Date().toISOString(),
            isComplete: false,
            avaliador: currentAvaliador,
            synced: false,
            totalQuestions: allQuestions.length,
            progress: currentProgress,
          };

          await StorageManager.saveResponse(responseToSave);
          console.log('✅ Anexos salvos localmente');
        }, 100);
        // IMPORTANTE: Atualizar stream quando anexos mudarem
        if (streamActive && streamId && activeEditingQuestion === questionId) {
          console.log('📤 Atualizando stream com novos anexos...');

          // Preparar anexos para o stream
          const streamAttachments = newAttachments.map(att => ({
            id: att.id || `att-${Date.now()}-${Math.random()}`,
            type: att.type || 'file',
            name: att.name || 'Anexo',
            description: att.description || '',
            validityDate: att.validityDate || null,
            mimeType: att.mimeType || 'application/octet-stream',
            size: att.size || 0,
            url: att.url || att.supabaseUrl || att.uri || att.base64 || '',
            // Adicionar campos extras para melhor visualização
            isImage: att.type === 'photo',
            isVideo: att.type === 'video',
            isLink: att.type === 'link',
          }));

          // Atualizar stream imediatamente
          updateStreamDebounced(
            streamId,
            {
              currentAttachments: streamAttachments,
            },
            true
          ).catch(error => {
            console.warn('⚠️ Erro ao atualizar stream com anexos:', error);
          });
        }
      }
    },
    [streamActive, streamId, activeEditingQuestion]
  );

  // Função para visualizar/baixar anexos
  const handleViewAttachment = useCallback(attachment => {
    console.log('🔍 Abrindo anexo:', attachment);

    if (attachment.type === 'link') {
      openLink(attachment.url);
    } else if (attachment.url) {
      openLocalFile(attachment);
    } else {
      Alert.alert('⚠️ Anexo Indisponível', 'Este anexo não pode ser visualizado no momento.', [
        { text: 'OK' },
      ]);
    }
  }, []);

  // Função para abrir links
  const openLink = useCallback(url => {
    let finalUrl = url;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      finalUrl = 'https://' + url;
    }

    Linking.canOpenURL(finalUrl)
      .then(supported => {
        if (supported) {
          Linking.openURL(finalUrl);
        } else {
          Alert.alert('❌ Erro', 'Não foi possível abrir o link');
        }
      })
      .catch(err => {
        console.error('Erro ao abrir link:', err);
        Alert.alert('❌ Erro', 'Erro ao tentar abrir o link');
      });
  }, []);

  // Função para abrir arquivos locais
  const openLocalFile = useCallback(attachment => {
    if (!attachment.url) {
      Alert.alert('❌ Erro', 'Arquivo não encontrado');
      return;
    }

    Linking.openURL(attachment.url).catch(err => {
      console.error('Erro ao abrir arquivo:', err);

      Alert.alert(
        '📎 Visualizar Anexo',
        `Nome: ${attachment.name || 'Arquivo'}\nTipo: ${attachment.type}\nTamanho: ${attachment.size ? formatFileSize(attachment.size) : 'N/A'}\nDescrição: ${attachment.description || 'Sem descrição'}`,
        [
          { text: 'OK' },
          {
            text: '📋 Copiar Caminho',
            onPress: () => {
              console.log('Caminho do arquivo:', attachment.url);
              Alert.alert('ℹ️ Info', 'Caminho copiado para o log do console');
            },
          },
        ]
      );
    });
  }, []);

  // Função para formatar tamanho de arquivo
  const formatFileSize = useCallback(bytes => {
    if (!bytes) return '';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }, []);

  // Obter emoji do tipo de arquivo
  const getFileEmoji = useCallback((mimeType, fileName) => {
    if (!mimeType && !fileName) return '📎';

    const type = mimeType?.toLowerCase() || fileName?.toLowerCase() || '';

    if (type.includes('pdf')) return '📄';
    if (type.includes('doc') || type.includes('word')) return '📝';
    if (type.includes('sheet') || type.includes('excel') || type.includes('csv')) return '📊';
    if (type.includes('zip') || type.includes('rar') || type.includes('7z')) return '🗜️';
    if (
      type.includes('image') ||
      type.includes('jpg') ||
      type.includes('png') ||
      type.includes('gif')
    )
      return '🖼️';
    if (type.includes('video') || type.includes('mp4') || type.includes('avi')) return '🎥';
    if (type.includes('audio') || type.includes('mp3') || type.includes('wav')) return '🎵';
    if (type.includes('text') || type.includes('txt')) return '📃';
    if (type.includes('presentation') || type.includes('ppt')) return '📽️';

    return '📎';
  }, []);

  // Função genérica para mostrar dialogs
  const showDialog = useCallback((title, message, actions = []) => {
    if (!isMountedRef.current) return;

    const defaultActions = [
      { text: 'Cancelar', action: () => setDialogVisible(false) },
      { text: 'Confirmar', action: () => setDialogVisible(false) },
    ];

    setDialogContent({
      title,
      message,
      actions: actions.length > 0 ? actions : defaultActions,
    });
    setDialogVisible(true);
  }, []);

  // Função para verificar se pode editar uma pergunta
  const canEditQuestion = useCallback(
    questionId => {
      if (!activeEditingQuestion) return true;
      if (activeEditingQuestion === questionId) return true;

      // Se tem stream ativo, atualizar quando trocar de questão
      if (streamActive && streamId && questionId !== activeEditingQuestion) {
        updateStreamForQuestion(questionId);
      }

      const activeQuestion = allQuestions.find(q => q.id === activeEditingQuestion);
      const activeQuestionCode = activeQuestion ? activeQuestion.codigo : activeEditingQuestion;

      showDialog(
        '⚠️ Pergunta em Edição',
        `Você está editando a pergunta ${activeQuestionCode}. Para responder outra pergunta, precisa concluir ou salvar esta resposta primeiro.`,
        [{ text: 'OK', action: () => setDialogVisible(false) }]
      );
      return false;
    },
    [
      activeEditingQuestion,
      allQuestions,
      showDialog,
      streamActive,
      streamId,
      updateStreamForQuestion,
    ]
  );

  // Modifique a função handleAnswer para chamar updateStreamForQuestion:

  // Modificar handleAnswer para incluir atualização do stream - VERSÃO MELHORADA
  const handleAnswer = useCallback(
    (questionId, answer) => {
      if (
        !canEditQuestion(questionId) ||
        !isMountedRef.current ||
        !initializationCompleteRef.current
      )
        return;

      // Focar na questão
      handleQuestionFocus(questionId);

      if (answer === 'nao-se-aplica') {
        setCurrentQuestionId(questionId);
        setTempNotApplicableText('');
        setNotApplicableDialogVisible(true);
        setActiveEditingQuestion(questionId);
        return;
      }

      setTimeout(() => {
        if (!isMountedRef.current) return;

        showDialog(
          '🔍 Confirmar Resposta',
          `Você escolheu: "${getAnswerLabel(answer)}". Deseja confirmar?`,
          [
            { text: 'Cancelar', action: () => setDialogVisible(false) },
            {
              text: 'Confirmar',
              action: async () => {
                if (!isMountedRef.current || !initializationCompleteRef.current) return;

                setAnswers(prev => ({
                  ...prev,
                  [questionId]: answer,
                }));

                setActiveEditingQuestion(questionId);
                // SALVAMENTO LOCAL IMEDIATO
                setTimeout(async () => {
                  if (!isMountedRef.current) return;

                  const updatedAnswers = { ...answers, [questionId]: answer };
                  const currentProgress = calculateCurrentProgress();

                  const responseToSave = {
                    id: responseIdRef.current || currentResponseId,
                    formId: form.id,
                    formTitle: formData.title,
                    answers: updatedAnswers,
                    findings: findings,
                    savedFindings: savedFindings,
                    notApplicableReasons: notApplicableReasons,
                    attachments: attachments,
                    createdAt: existingResponse?.createdAt || new Date().toISOString(),
                    lastModified: new Date().toISOString(),
                    isComplete: false,
                    avaliador: currentAvaliador,
                    synced: false,
                    totalQuestions: allQuestions.length,
                    progress: currentProgress,
                  };

                  await StorageManager.saveResponse(responseToSave);
                  console.log('✅ Resposta salva localmente após marcar:', answer);
                }, 100);

                // Atualizar stream se ativo - VERSÃO MELHORADA
                if (streamActive && streamId) {
                  try {
                    await updateStreamDebounced(
                      streamId,
                      {
                        currentAnswer: answer,
                        questionStatus: 'saved',
                      },
                      true
                    );
                  } catch (error) {
                    console.warn('⚠️ Erro ao atualizar stream com resposta:', error);
                  }
                }

                if (notApplicableReasons[questionId]) {
                  setNotApplicableReasons(prev => {
                    const newReasons = { ...prev };
                    delete newReasons[questionId];
                    return newReasons;
                  });
                }

                if (savedFindings[questionId]) {
                  setSavedFindings(prev => {
                    const newSaved = { ...prev };
                    delete newSaved[questionId];
                    return newSaved;
                  });
                }
              },
            },
          ]
        );
      }, 100);
    },
    [
      canEditQuestion,
      handleQuestionFocus,
      showDialog,
      getAnswerLabel,
      notApplicableReasons,
      savedFindings,
      streamActive,
      streamId,
    ]
  );

  // FUNÇÃO CORRIGIDA: Lidar com justificativa de "Não se Aplica"
  const handleNotApplicableSubmit = useCallback(() => {
    if (!isMountedRef.current || !initializationCompleteRef.current) return;

    if (tempNotApplicableText.trim().length < 3) {
      showDialog(
        '⚠️ Texto Insuficiente',
        'Por favor, digite pelo menos 3 caracteres para justificar o "Não se Aplica".',
        [{ text: 'OK', action: () => setDialogVisible(false) }]
      );
      return;
    }

    setAnswers(prev => ({
      ...prev,
      [currentQuestionId]: 'nao-se-aplica',
    }));

    setNotApplicableReasons(prev => ({
      ...prev,
      [currentQuestionId]: tempNotApplicableText.trim(),
    }));

    // Atualizar stream
    if (streamActive && streamId) {
      updateStreamDebounced(
        streamId,
        {
          notApplicableReason: tempNotApplicableText.trim(),
          questionStatus: 'saved',
        },
        true
      );
    }

    setActiveEditingQuestion(null);

    setNotApplicableDialogVisible(false);
    setCurrentQuestionId(null);
    setTempNotApplicableText('');
  }, [tempNotApplicableText, currentQuestionId, showDialog, streamActive, streamId]);

  // Função para obter rótulo de resposta
  const getAnswerLabel = useCallback(answer => {
    switch (answer) {
      case 'conforme':
        return '✅ Conforme';
      case 'nao-conforme':
        return '❌ Não Conforme';
      case 'nao-se-aplica':
        return '➖ Não se Aplica';
      default:
        return answer;
    }
  }, []);

  // Modifique também handleFindingChange:

  // Modificar handleFindingChange para atualização em tempo real - VERSÃO MELHORADA
  const handleFindingChange = useCallback(
    (questionId, text) => {
      if (
        !canEditQuestion(questionId) ||
        !isMountedRef.current ||
        !initializationCompleteRef.current
      )
        return;

      // Focar se não estiver focado
      if (!activeEditingQuestion || activeEditingQuestion !== questionId) {
        handleQuestionFocus(questionId);
      }

      setFindings(prev => ({
        ...prev,
        [questionId]: text,
      }));

      // Atualizar stream em tempo real - VERSÃO MELHORADA
      if (streamActive && streamId && questionId === activeEditingQuestion) {
        // Usar debounce para digitação
        updateStreamDebounced(streamId, {
          currentFindings: text,
        }).catch(error => {
          // Ignorar erros de timeout durante digitação
          if (!error.message.includes('timeout')) {
            console.warn('⚠️ Erro ao atualizar stream com achados:', error);
          }
        });
      }
    },
    [canEditQuestion, streamActive, streamId, activeEditingQuestion, handleQuestionFocus]
  );

  // Adicionar função para atualizar progresso no stream
  const updateStreamProgress = useCallback(async () => {
    if (!streamActive || !streamId) return;

    try {
      const allQuestionsForStream = allQuestions.map(q => ({
        id: q.id,
        codigo: q.codigo,
        isAnswered: !!answers[q.id],
      }));

      await updateStreamDebounced(
        streamId,
        {
          progress: {
            answeredCount: responseStats.answeredCount,
            totalQuestions: allQuestions.length,
            percentage: responseStats.completionPercentage,
            completedQuestions: Object.keys(answers),
          },
          allQuestions: allQuestionsForStream,
          questionStatus: 'selecting',
        },
        true
      );
    } catch (error) {
      console.warn('⚠️ Erro ao atualizar progresso do stream:', error);
    }
  }, [streamActive, streamId, allQuestions, answers, responseStats]);

  // Adicionar useEffect para atualizar progresso quando as respostas mudarem
  useEffect(() => {
    if (streamActive && streamId && isInitialized) {
      const timeoutId = setTimeout(() => {
        updateStreamProgress();
      }, 1000); // Aguardar 1 segundo para evitar muitas atualizações

      return () => clearTimeout(timeoutId);
    }
  }, [answers, streamActive, streamId, isInitialized, updateStreamProgress]);

  // FUNÇÃO CORRIGIDA: Salvar achados
  const saveFinding = useCallback(
    questionId => {
      if (!isMountedRef.current || !initializationCompleteRef.current) return;

      const finding = findings[questionId];
      if (!finding || finding.trim().length < 3) {
        showDialog(
          '⚠️ Texto Insuficiente',
          'Por favor, digite pelo menos 3 caracteres no registro dos achados.',
          [{ text: 'OK', action: () => setDialogVisible(false) }]
        );
        return;
      }

      showDialog('✅ Achado Salvo!', 'O registro dos achados foi salvo com sucesso.', [
        {
          text: 'OK',
          action: () => {
            if (!isMountedRef.current || !initializationCompleteRef.current) return;

            setSavedFindings(prev => ({
              ...prev,
              [questionId]: true,
            }));

            // Atualizar stream
            if (streamActive && streamId) {
              updateStreamDebounced(
                streamId,
                {
                  questionStatus: 'saved',
                },
                true
              );
            }

            setActiveEditingQuestion(null);
            setDialogVisible(false);
          },
        },
      ]);
    },
    [findings, showDialog, streamActive, streamId]
  );

  // Função para editar achados
  const editFinding = useCallback(
    questionId => {
      showDialog(
        '✏️ Editar Achados',
        'Deseja realmente editar o registro dos achados? As alterações só serão salvas após confirmar.',
        [
          { text: 'Cancelar', action: () => setDialogVisible(false) },
          {
            text: 'Sim, Editar',
            action: () => {
              if (!isMountedRef.current || !initializationCompleteRef.current) return;

              setSavedFindings(prev => {
                const newSaved = { ...prev };
                delete newSaved[questionId];
                return newSaved;
              });
              setActiveEditingQuestion(questionId);
              setDialogVisible(false);
            },
          },
        ]
      );
    },
    [showDialog]
  );

  // Função para expandir/recolher seções
  const toggleSection = useCallback(sectionId => {
    if (!isMountedRef.current || !initializationCompleteRef.current) return;

    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  }, []);

  // Função para rolar até uma pergunta específica
  const scrollToQuestion = useCallback(questionIndex => {
    const questionRef = questionRefs.current[questionIndex];

    if (questionRef) {
      questionRef.measureInWindow((x, y, width, height) => {
        const currentPageScroll = window.pageYOffset || document.documentElement.scrollTop;
        const headerOffset = 200;
        const targetScrollPosition = currentPageScroll + y - headerOffset;

        window.scrollTo({
          top: Math.max(0, targetScrollPosition),
          behavior: 'smooth',
        });
      });
    } else {
      const estimatedQuestionHeight = 500;
      const totalHeaderHeight = 220;
      const estimatedPosition = totalHeaderHeight + questionIndex * estimatedQuestionHeight;

      window.scrollTo({
        top: estimatedPosition,
        behavior: 'smooth',
      });
    }
  }, []);

  // FUNÇÃO COMPLETAMENTE CORRIGIDA: Salvar resposta ULTRA OTIMIZADA
  const saveResponseData = useCallback(
    async (isComplete = false, isAutoSave = false) => {
      if (!initializationCompleteRef.current && isAutoSave) {
        return false;
      }

      if (saveInProgressRef.current) {
        return false;
      }

      if (!isMountedRef.current) {
        return false;
      }

      try {
        saveInProgressRef.current = true;
        setIsSaving(true);

        const responseId = responseIdRef.current || currentResponseId;

        if (!responseId) {
          const newId = generateUniqueResponseId();
          setCurrentResponseId(newId);
          responseIdRef.current = newId;
        }

        const totalQuestions = allQuestions.length;
        const answeredQuestions = Object.keys(answers).length;
        const progressPercentage =
          totalQuestions > 0 ? Math.round((answeredQuestions / totalQuestions) * 100) : 0;

        // CORREÇÃO: Validar avaliador antes de salvar
        let validAvaliador = currentAvaliador;
        if (!validAvaliador || !validAvaliador.id || validAvaliador.id === 'visitor') {
          validAvaliador = {
            id: 'av00',
            nome: 'Usuário Não Identificado',
            login: 'sem_email@ebserh.gov.br',
            level: 'membro',
          };
          console.warn('⚠️ Avaliador inválido, usando padrão:', validAvaliador);
        }

        const responseData = {
          id: responseId,
          formId: form.id,
          formTitle: formData.title,
          answers,
          findings,
          savedFindings,
          notApplicableReasons,
          attachments,
          createdAt: existingResponse?.createdAt || new Date().toISOString(),
          completedAt: isComplete ? new Date().toISOString() : null,
          lastModified: new Date().toISOString(),
          isComplete: isComplete,
          avaliador: validAvaliador,
          // Preservar informações de validação se estiver no modo validação
          ...(form.isValidationMode && form.originalAvaliador
            ? {
                avaliadorOriginal: form.originalAvaliador,
                validadoPor: currentAvaliador,
                dataValidacao: new Date().toISOString(),
                modoValidacao: true,
              }
            : {}),
          validacao: {
            validadoPor: null,
            dataValidacao: null,
            revalidacoes: [],
          },
          synced: false,
          totalQuestions: totalQuestions,
          progress: {
            answered: answeredQuestions,
            total: totalQuestions,
            percentage: progressPercentage,
          },
          editedFromResults: isEditingFromResults,
          syncStatus: 'local-only',
        };

        await StorageManager.addDownloadedFormId(form.id);
        await StorageManager.saveResponse(responseData);

        // Se não for auto-save OU for uma resposta completa, tentar sincronizar com servidor

        {
          /*         if (!isAutoSave || isComplete) {
          try {
            // Verificar se tem conexão
            const { checkServerHealth } = await import('../lib/api');
            const health = await checkServerHealth();

            if (health.status === 'online') {
              console.log('🔄 Tentando sincronizar com servidor...');
              const { saveResponse } = await import('../lib/api');
              const syncedResponse = await saveResponse(responseData);

              if (syncedResponse && syncedResponse.synced) {
                // Atualizar localmente com status sincronizado
                await StorageManager.updateResponseSyncStatus(
                  responseData.id,
                  true,
                  syncedResponse.syncedAt
                );
                console.log('✅ Resposta sincronizada com servidor');

                // Se for resposta completa, adicionar log especial
                if (isComplete) {
                  console.log('🎉 Formulário completo sincronizado com sucesso!');
                }
              }
            }
          } catch (syncError) {
            console.log('⚠️ Não foi possível sincronizar agora:', syncError.message);
            // Continuar normalmente, será sincronizado depois
          }
        }*/
        }

        // Atualizar progresso no stream se ativo
        if (streamActive && streamId && !isAutoSave) {
          const allQuestionsForStream = allQuestions.map(q => ({
            id: q.id,
            codigo: q.codigo,
            isAnswered: !!answers[q.id],
          }));

          updateStreamDebounced(
            streamId,
            {
              progress: {
                answeredCount: answeredQuestions,
                totalQuestions: totalQuestions,
                percentage: progressPercentage,
                completedQuestions: Object.keys(answers),
              },
              allQuestions: allQuestionsForStream,
              questionStatus: 'selecting',
            },
            true
          );
        }

        if (isMountedRef.current) {
          setExistingResponse(responseData);
          setCurrentResponseId(responseId);

          const newSnapshot = createDataSnapshot();
          lastDataSnapshotRef.current = newSnapshot;
          setHasUnsavedChanges(false);

          if (!isAutoSave) {
            notifyFormUpdate(responseData);
          }
        }

        return true;
      } catch (error) {
        console.error('❌ Erro ao salvar resposta:', error);
        return false;
      } finally {
        if (isMountedRef.current) {
          setIsSaving(false);
        }
        saveInProgressRef.current = false;
      }
    },
    [
      currentResponseId,
      generateUniqueResponseId,
      allQuestions.length,
      answers,
      findings,
      savedFindings,
      notApplicableReasons,
      attachments,
      form.id,
      formData?.title,
      existingResponse,
      isEditingFromResults,
      currentAvaliador,
      createDataSnapshot,
      notifyFormUpdate,
      streamActive,
      streamId,
    ]
  );

  // FUNÇÃO CORRIGIDA: Salvar progresso parcial
  // FUNÇÃO CORRIGIDA: Salvar progresso parcial
  // FUNÇÃO CORRIGIDA: Salvar progresso parcial COM TENTATIVA DE UPLOAD
  const savePartialProgress = useCallback(async () => {
    if (!isMountedRef.current || !initializationCompleteRef.current) return;

    // Verificar se está editando uma pergunta
    if (activeEditingQuestion) {
      const activeQuestion = allQuestions.find(q => q.id === activeEditingQuestion);
      const activeQuestionCode = activeQuestion ? activeQuestion.codigo : activeEditingQuestion;

      showDialog(
        '⚠️ Pergunta em Edição',
        `Você está editando a pergunta ${activeQuestionCode}. É necessário concluir ou salvar os achados desta pergunta antes de salvar o progresso do formulário.`,
        [{ text: 'OK', action: () => setDialogVisible(false) }]
      );
      return;
    }

    if (responseStats.answeredCount === 0) {
      showDialog('⚠️ Aviso', 'Responda pelo menos uma pergunta antes de salvar.', [
        { text: 'OK', action: () => setDialogVisible(false) },
      ]);
      return;
    }

    // Se está completo, chamar a função de salvar completo
    if (responseStats.isComplete) {
      await saveCompleteResponse();
      return;
    }

    // ✅ NOVO: Mostrar dialog de loading com countdown
    setSavingProgressDialog(true);
    setSavingCountdown(20);

    // Iniciar countdown
    const countdownInterval = setInterval(() => {
      setSavingCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    try {
      // Salvar localmente primeiro
      const success = await saveResponseData(false);

      if (!success) {
        clearInterval(countdownInterval);
        setSavingProgressDialog(false);
        showDialog('❌ Erro', 'Falha ao salvar progresso. Tente novamente.', [
          { text: 'OK', action: () => setDialogVisible(false) },
        ]);
        return;
      }

      if (!isMountedRef.current) return;

      setActiveEditingQuestion(null);
      const totalAttachments = Object.values(attachments).reduce(
        (total, arr) => total + arr.length,
        0
      );

      let cloudSuccess = false;
      let errorMessage = '';

      // Tentar fazer upload para a nuvem
      try {
        console.log('🔄 Tentando enviar progresso para a nuvem...');

        const { checkServerHealth } = await import('../lib/api');
        const health = await checkServerHealth();

        if (health.status === 'online') {
          const responseToUpload = {
            id: responseIdRef.current || currentResponseId,
            formId: form.id,
            formTitle: formData.title,
            answers,
            findings,
            savedFindings,
            notApplicableReasons,
            attachments,
            createdAt: existingResponse?.createdAt || new Date().toISOString(),
            completedAt: null,
            lastModified: new Date().toISOString(),
            isComplete: false,
            avaliador: currentAvaliador,
            synced: false,
            totalQuestions: allQuestions.length,
            progress: {
              answered: responseStats.answeredCount,
              total: allQuestions.length,
              percentage: responseStats.completionPercentage,
            },
          };

          const { saveResponse } = await import('../lib/api');
          const syncedResponse = await saveResponse(responseToUpload);

          if (syncedResponse && syncedResponse.synced) {
            console.log('✅ Progresso sincronizado automaticamente com o servidor!');

            const StorageManager = await import('../utils/StorageManager').then(m => m.default);
            await StorageManager.updateResponseSyncStatus(
              responseToUpload.id,
              true,
              syncedResponse.syncedAt
            );

            cloudSuccess = true;
          }
        } else {
          errorMessage = 'Servidor offline';
        }
      } catch (uploadError) {
        console.warn('⚠️ Erro ao enviar ao servidor:', uploadError.message);
        errorMessage = uploadError.message || 'Erro desconhecido';
        cloudSuccess = false;
      }

      // Parar countdown
      clearInterval(countdownInterval);
      setSavingProgressDialog(false);

      // Mostrar resultado
      if (cloudSuccess) {
        showDialog(
          '💾 Progresso Salvo e Enviado!',
          `${responseStats.answeredCount} de ${allQuestions.length} perguntas respondidas (${responseStats.completionPercentage}%).${totalAttachments > 0 ? `\n📎 ${totalAttachments} anexo(s) incluído(s).` : ''}\n\n✅ Seu progresso foi salvo E enviado para a nuvem ☁️!`,
          [
            { text: '✏️ Continuar Aqui', action: () => setDialogVisible(false) },
            {
              text: '🏠 Voltar ao Início',
              action: () => {
                setDialogVisible(false);
                if (typeof onBack === 'function') {
                  onBack();
                }
              },
            },
          ]
        );
      } else {
        showDialog(
          '💾 Progresso Salvo Localmente!',
          `${responseStats.answeredCount} de ${allQuestions.length} perguntas respondidas (${responseStats.completionPercentage}%).${totalAttachments > 0 ? `\n📎 ${totalAttachments} anexo(s) incluído(s).` : ''}\n\n📱 Seu progresso foi salvo no dispositivo!\n⚠️ Não foi possível enviar para a nuvem: ${errorMessage}\n\n💡 Para enviar quando tiver conexão, acesse a 📁 Pasta de Uploads e clique em 📤 Enviar.`,
          [
            { text: '✏️ Continuar Aqui', action: () => setDialogVisible(false) },
            {
              text: '🏠 Voltar ao Início',
              action: () => {
                setDialogVisible(false);
                if (typeof onBack === 'function') {
                  onBack();
                }
              },
            },
          ]
        );
      }
    } catch (error) {
      console.error('❌ Erro geral ao salvar:', error);
      clearInterval(countdownInterval);
      setSavingProgressDialog(false);
      showDialog('❌ Erro', 'Falha ao salvar progresso. Tente novamente.', [
        { text: 'OK', action: () => setDialogVisible(false) },
      ]);
    }
  }, [
    responseStats,
    saveResponseData,
    saveCompleteResponse,
    showDialog,
    attachments,
    allQuestions.length,
    onBack,
    activeEditingQuestion,
    allQuestions,
    currentAvaliador,
    form.id,
    formData?.title,
    answers,
    findings,
    savedFindings,
    notApplicableReasons,
    currentResponseId,
    existingResponse,
  ]);

  // FUNÇÃO CORRIGIDA: Salvar e finalizar resposta
  // FUNÇÃO CORRIGIDA: Salvar e finalizar resposta
  const saveCompleteResponse = useCallback(async () => {
    if (!isMountedRef.current || !initializationCompleteRef.current) return;

    if (!responseStats.isComplete) {
      showDialog(
        '⚠️ Formulário Incompleto',
        `Você precisa responder TODAS as ${allQuestions.length} perguntas para finalizar.\n\nAtualmente: ${responseStats.answeredCount}/${allQuestions.length} respondidas (${responseStats.completionPercentage}%)\n\nContinue preenchendo ou salve como rascunho.`,
        [
          { text: '💾 Salvar Rascunho', action: savePartialProgress },
          { text: '✏️ Continuar Preenchendo', action: () => setDialogVisible(false) },
        ]
      );
      return;
    }

    // ✅ NOVO: Mostrar dialog de loading com countdown
    setSavingProgressDialog(true);
    setSavingCountdown(20);

    // Iniciar countdown
    const countdownInterval = setInterval(() => {
      setSavingCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    try {
      // Salvar localmente primeiro
      const success = await saveResponseData(true);

      if (!success) {
        clearInterval(countdownInterval);
        setSavingProgressDialog(false);
        showDialog('❌ Erro', 'Falha ao salvar respostas. Tente novamente.', [
          { text: 'OK', action: () => setDialogVisible(false) },
        ]);
        return;
      }

      if (!isMountedRef.current) return;

      setActiveEditingQuestion(null);
      const totalAttachments = Object.values(attachments).reduce(
        (total, arr) => total + arr.length,
        0
      );

      let cloudSuccess = false;
      let errorMessage = '';

      try {
        const { checkServerHealth } = await import('../lib/api');
        const health = await checkServerHealth();

        if (health.status === 'online') {
          console.log('🔄 Enviando formulário completo para o servidor...');

          const responseToUpload = {
            id: responseIdRef.current || currentResponseId,
            formId: form.id,
            formTitle: formData.title,
            answers,
            findings,
            savedFindings,
            notApplicableReasons,
            attachments,
            createdAt: existingResponse?.createdAt || new Date().toISOString(),
            completedAt: new Date().toISOString(),
            lastModified: new Date().toISOString(),
            isComplete: true,
            avaliador: currentAvaliador,
            synced: false,
            totalQuestions: allQuestions.length,
            progress: {
              answered: allQuestions.length,
              total: allQuestions.length,
              percentage: 100,
            },
          };

          const { saveResponse } = await import('../lib/api');
          const syncedResponse = await saveResponse(responseToUpload);

          if (syncedResponse && syncedResponse.synced) {
            const StorageManager = await import('../utils/StorageManager').then(m => m.default);
            await StorageManager.updateResponseSyncStatus(
              responseToUpload.id,
              true,
              syncedResponse.syncedAt
            );

            console.log('✅ Formulário completo enviado e sincronizado com servidor!');
            cloudSuccess = true;
          }
        } else {
          errorMessage = 'Servidor offline';
        }
      } catch (uploadError) {
        console.warn('⚠️ Não foi possível enviar ao servidor:', uploadError.message);
        errorMessage = uploadError.message || 'Erro desconhecido';
        cloudSuccess = false;
      }

      // Parar countdown
      clearInterval(countdownInterval);
      setSavingProgressDialog(false);

      // Mostrar resultado
      if (cloudSuccess) {
        showDialog(
          '🎉 Formulário Concluído e Enviado!',
          `✅ Todas as respostas foram salvas e enviadas para o servidor com sucesso!\n\n${totalAttachments > 0 ? `📎 ${totalAttachments} anexo(s) incluído(s).\n\n` : ''}☁️ Seu formulário está sincronizado na nuvem e disponível para consulta.`,
          [
            {
              text: '🏠 Ir para o Início',
              action: () => {
                setDialogVisible(false);
                if (typeof onBack === 'function') {
                  onBack();
                }
              },
            },
            {
              text: '✏️ Continuar Aqui',
              action: () => setDialogVisible(false),
            },
          ]
        );
      } else {
        showDialog(
          '🎉 Formulário Concluído!',
          `✅ Todas as respostas foram salvas localmente.\n\n${totalAttachments > 0 ? `📎 ${totalAttachments} anexo(s) incluído(s).\n\n` : ''}⚠️ Não foi possível enviar ao servidor: ${errorMessage}\n\n💡 Para enviar, acesse a "Pasta de Upload" quando tiver conexão com a internet.`,
          [
            {
              text: '🏠 Ir para o Início',
              action: () => {
                setDialogVisible(false);
                if (typeof onBack === 'function') {
                  onBack();
                }
              },
            },
            {
              text: '✏️ Continuar Aqui',
              action: () => setDialogVisible(false),
            },
          ]
        );
      }
    } catch (error) {
      console.error('❌ Erro geral ao salvar:', error);
      clearInterval(countdownInterval);
      setSavingProgressDialog(false);
      showDialog('❌ Erro', 'Falha ao salvar respostas. Tente novamente.', [
        { text: 'OK', action: () => setDialogVisible(false) },
      ]);
    }
  }, [
    responseStats,
    saveResponseData,
    showDialog,
    allQuestions.length,
    attachments,
    onBack,
    savePartialProgress,
    currentAvaliador,
    form.id,
    formData?.title,
    answers,
    findings,
    savedFindings,
    notApplicableReasons,
    existingResponse,
    currentResponseId,
  ]);

  // Função para resetar formulário
  const resetForm = useCallback(() => {
    showDialog(
      '🗑️ Confirmar Exclusão?',
      `Deseja realmente excluir permanentemente todas as respostas deste formulário?\n\n⚠️ Esta ação irá remover TODAS as respostas salvas e não pode ser desfeita.`,
      [
        { text: 'Cancelar', action: () => setDialogVisible(false) },
        {
          text: '🗑️ Sim, Excluir',
          action: async () => {
            try {
              if (existingResponse) {
                await StorageManager.removeResponse(existingResponse.id);
                console.log(
                  `✅ Respostas do formulário ${form.id} removidas do armazenamento local`
                );
              }

              if (isMountedRef.current) {
                setAnswers({});
                setFindings({});
                setSavedFindings({});
                setNotApplicableReasons({});
                setAttachments({});
                setActiveEditingQuestion(null);
                setExistingResponse(null);
                setHasUnsavedChanges(false);

                const emptySnapshot = createDataSnapshot();
                lastDataSnapshotRef.current = emptySnapshot;

                const newId = generateUniqueResponseId();
                setCurrentResponseId(newId);
                responseIdRef.current = newId;

                notifyFormUpdate(null);
              }

              showDialog(
                '✅ Exclusão Concluída',
                'Todas as respostas e anexos foram removidos permanentemente do dispositivo. Você pode começar a responder novamente.',
                [
                  {
                    text: 'Continuar Aqui',
                    action: () => setDialogVisible(false),
                  },
                  {
                    text: '🏠 Voltar ao Início',
                    action: () => {
                      setDialogVisible(false);
                      if (typeof onBack === 'function') {
                        onBack();
                      }
                    },
                  },
                ]
              );
            } catch (error) {
              console.error('❌ Erro ao excluir respostas:', error);
              showDialog(
                '❌ Erro na Exclusão',
                'Ocorreu um erro ao tentar excluir as respostas. Tente novamente.',
                [{ text: 'OK', action: () => setDialogVisible(false) }]
              );
            }
          },
        },
      ]
    );
  }, [
    showDialog,
    existingResponse,
    form.id,
    createDataSnapshot,
    generateUniqueResponseId,
    notifyFormUpdate,
    onBack,
  ]);

  // Função para obter status da pergunta
  const getQuestionStatus = useCallback(
    questionIndex => {
      const question = allQuestions[questionIndex];
      const hasAnswer = answers[question.id];

      if (hasAnswer) return 'answered';
      return 'pending';
    },
    [allQuestions, answers]
  );

  // Função para obter cor do status da pergunta
  const getQuestionStatusColor = useCallback(status => {
    switch (status) {
      case 'answered':
        return AVAQualisTheme.colors.success;
      default:
        return AVAQualisTheme.colors.outline;
    }
  }, []);

  // OTIMIZAÇÃO: Memoizar header fixo
  const fixedHeader = useMemo(
    () => (
      <View style={styles.fixedHeaderContainer}>
        <View style={styles.progressContainer}>
          <View style={styles.progressHeader}>
            <View style={styles.progressInfo}>
              <View style={styles.progressTextContainer}>
                <Text style={styles.progressText}>
                  📊 {responseStats.completionPercentage}% concluído
                </Text>
                <Text style={styles.progressSubtext}>
                  {responseStats.answeredCount} de {allQuestions.length} respondidas
                </Text>
                {currentResponseId && (
                  <Text style={styles.progressIdText}>ID: {currentResponseId.substr(-8)}</Text>
                )}
              </View>
            </View>
            <Badge style={styles.progressBadge}>
              {responseStats.answeredCount}/{allQuestions.length}
            </Badge>
          </View>

          <ProgressBar
            progress={responseStats.progress}
            color={
              responseStats.isComplete
                ? AVAQualisTheme.colors.success
                : AVAQualisTheme.colors.primary
            }
            style={styles.progressBar}
          />
        </View>

        {currentAvaliador && (
          <View style={styles.avaliadorInfo}>
            <Text style={styles.avaliadorInfoText}>
              {form.isValidationMode && form.originalAvaliador ? (
                <>
                  👤 Avaliador Original: {getLevelEmoji(form.originalAvaliador.level)}{' '}
                  {form.originalAvaliador.nome} ({getLevelDescription(form.originalAvaliador.level)}
                  ){'\n'}
                  👁️ Validando como: {getLevelEmoji(currentAvaliador.level)} {currentAvaliador.nome}
                </>
              ) : (
                <>
                  {getLevelEmoji(currentAvaliador.level)} {currentAvaliador.nome} (
                  {getLevelDescription(currentAvaliador.level)})
                </>
              )}
            </Text>
          </View>
        )}

        {/* Status de salvamento */}
        {!responseStats.isComplete && isSaving && (
          <View style={styles.completionNotice}>
            <Text style={styles.completionNoticeText}>💾 Salvando progresso...</Text>
          </View>
        )}

        {!responseStats.isComplete && !isSaving && hasUnsavedChanges && (
          <View style={styles.completionNotice}>
            <Text style={styles.completionNoticeText}>
              📝 Mudanças não salvas • Auto-save em {Math.round(AUTO_SAVE_DELAY / 1000)}s
            </Text>
          </View>
        )}

        {!responseStats.isComplete &&
          !isSaving &&
          !hasUnsavedChanges &&
          responseStats.answeredCount > 0 && (
            <View style={styles.completionNotice}>
              <Text style={styles.completionNoticeText}>
                ✅ Progresso salvo • {responseStats.answeredCount} resposta(s)
              </Text>
            </View>
          )}

        {responseStats.isComplete && !isSaving && (
          <View
            style={[
              styles.completionNotice,
              {
                backgroundColor: `${AVAQualisTheme.colors.success}15`,
                borderLeftColor: AVAQualisTheme.colors.success,
              },
            ]}
          >
            <Text style={[styles.completionNoticeText, { color: AVAQualisTheme.colors.success }]}>
              🎉 100% Completo! Clique em "Salvar" para preparar o upload
            </Text>
          </View>
        )}

        {!responseStats.isComplete && !isSaving && responseStats.answeredCount === 0 && (
          <View style={styles.completionNotice}>
            <Text style={styles.completionNoticeText}>
              ⚠️ Responda as perguntas e salve seu progresso regularmente
            </Text>
          </View>
        )}
        {activeEditingQuestion && (
          <View style={styles.editingNotice}>
            <Text style={styles.editingNoticeText}>
              ✏️ Editando pergunta:{' '}
              {allQuestions.find(q => q.id === activeEditingQuestion)?.codigo ||
                activeEditingQuestion}
            </Text>
          </View>
        )}

        {/* Navegação */}
        <View style={styles.questionNav}>
          <Text style={styles.questionNavTitle}>🔗 Ir para pergunta:</Text>
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={styles.questionNavScroll}
          >
            {allQuestions.map((question, index) => {
              const status = getQuestionStatus(index);
              const color = getQuestionStatusColor(status);
              return (
                <Button
                  key={question.id}
                  mode={status === 'answered' ? 'contained' : 'outlined'}
                  onPress={() => scrollToQuestion(index)}
                  style={[styles.questionNavButton, { borderColor: color }]}
                  buttonColor={status === 'answered' ? color : 'transparent'}
                  textColor={
                    status === 'answered'
                      ? AVAQualisTheme.colors.onPrimary
                      : AVAQualisTheme.colors.onSurface
                  }
                  compact
                  rippleColor={`${color}30`}
                >
                  <View style={styles.navButtonContent}>
                    <Text
                      style={[
                        styles.navButtonText,
                        {
                          color:
                            status === 'answered'
                              ? AVAQualisTheme.colors.onPrimary
                              : AVAQualisTheme.colors.onSurface,
                        },
                      ]}
                    >
                      {status === 'answered' ? '✅' : '📋'} {question.codigo}
                    </Text>
                    {question.isEssential && (
                      <View style={styles.navEssentialBadge}>
                        <Text style={styles.navEssentialIcon}>⚠️</Text>
                        <Text style={styles.navEssentialText}>RE</Text>
                      </View>
                    )}
                  </View>
                </Button>
              );
            })}
          </ScrollView>
        </View>
      </View>
    ),
    [
      responseStats,
      allQuestions.length,
      currentResponseId,
      currentAvaliador,
      isSaving,
      hasUnsavedChanges,
      activeEditingQuestion,
      getQuestionStatus,
      getQuestionStatusColor,
      scrollToQuestion,
    ]
  );

  // OTIMIZAÇÃO: Memoizar botões de ação final
  // OTIMIZAÇÃO: Memoizar botões de ação final
  // OTIMIZAÇÃO: Memoizar botões de ação final
  const finalActionButtons = useMemo(() => {
    // Se está em modo validação e formulário está completo
    if (form?.isValidationMode && responseStats.isComplete) {
      const isAlreadyValidated = form?.existingResponse?.validacao?.validadoPor !== null;

      return (
        <View style={styles.finalActions}>
          <Button
            mode="contained"
            onPress={async () => {
              try {
                console.log('🔍 DEBUG: Iniciando validação...');
                console.log('📋 Response ID:', form.existingResponse?.id);
                console.log('👤 Validador:', currentAvaliador);

                // Salvar dados localmente primeiro
                await saveResponseData(true);

                // Validar a resposta
                const { validateResponse } = await import('../lib/api');
                const validador = {
                  id: currentAvaliador.id,
                  nome: currentAvaliador.nome,
                  login: currentAvaliador.email || currentAvaliador.login,
                  level: currentAvaliador.level,
                };

                console.log('📤 Enviando validação para o servidor...');
                const validatedResponse = await validateResponse(
                  form.existingResponse.id,
                  validador
                );
                console.log('✅ Resposta validada:', validatedResponse);

                // IMPORTANTE: Atualizar o cache local com a resposta validada
                const StorageManager = await import('../utils/StorageManager').then(m => m.default);

                // Atualizar a resposta no StorageManager com os dados de validação
                const updatedResponse = {
                  ...form.existingResponse,
                  validacao: {
                    validadoPor: validador,
                    dataValidacao: new Date().toISOString(),
                    revalidacoes: form.existingResponse?.validacao?.revalidacoes || [],
                  },
                  synced: true,
                  syncedAt: new Date().toISOString(),
                };

                console.log('💾 Salvando resposta validada no cache local...');
                await StorageManager.saveResponse(updatedResponse);

                // Atualizar também no AsyncStorage para o cache da API
                await AsyncStorage.setItem(
                  `cached_response_${form.existingResponse.id}`,
                  JSON.stringify(updatedResponse)
                );

                console.log(
                  '🔍 DEBUG: Salvando indicador de redirecionamento para ValidationScreen'
                );

                // Salvar indicador para ir para ValidationScreen após reload
                if (Platform.OS === 'web') {
                  localStorage.setItem('redirectToValidation', 'true');
                  localStorage.setItem(
                    'validationMessage',
                    isAlreadyValidated ? 'revalidated' : 'validated'
                  );
                } else {
                  await AsyncStorage.setItem('redirectToValidation', 'true');
                  await AsyncStorage.setItem(
                    'validationMessage',
                    isAlreadyValidated ? 'revalidated' : 'validated'
                  );
                }

                // Mostrar mensagem de sucesso e fazer reload
                if (Platform.OS === 'web' && typeof window !== 'undefined') {
                  console.log('🔍 DEBUG: Redirecionando diretamente...');
                  window.location.href = '/';
                  setTimeout(() => {
                    window.location.reload();
                  }, 100);
                } else {
                  Alert.alert(
                    isAlreadyValidated ? '✅ Revalidação Concluída' : '✅ Validação Concluída',
                    isAlreadyValidated
                      ? 'O formulário foi revalidado com sucesso!'
                      : 'O formulário foi validado com sucesso!',
                    [
                      {
                        text: 'OK',
                        onPress: () => {
                          if (typeof onBack === 'function') {
                            onBack();
                          }
                        },
                      },
                    ]
                  );
                }
              } catch (error) {
                console.error('❌ Erro ao validar:', error);
                Alert.alert(
                  '❌ Erro',
                  `Não foi possível ${isAlreadyValidated ? 'revalidar' : 'validar'} o formulário. Erro: ${error.message}`
                );
              }
            }}
            icon={isAlreadyValidated ? 'refresh' : 'check-decagram'}
            style={[styles.saveButton, styles.completeButton]}
            buttonColor={AVAQualisTheme.colors.success}
            textColor={AVAQualisTheme.colors.onPrimary}
            disabled={isSaving}
            loading={isSaving}
          >
            {isAlreadyValidated
              ? `✅ Validar ou 🔄 Revalidar Formulário (100% Completo)`
              : `✅ Validar Formulário (100% Completo)`}
          </Button>

          <View
            style={[styles.finalizationWarning, { borderLeftColor: AVAQualisTheme.colors.success }]}
          >
            <Text
              style={[styles.finalizationWarningText, { color: AVAQualisTheme.colors.success }]}
            >
              ✅ Formulário 100% completo e pronto para{' '}
              {isAlreadyValidated ? 'revalidação' : 'validação'}!
            </Text>
            <Text style={styles.finalizationWarningSubtext}>
              Todas as {allQuestions.length} perguntas foram respondidas.
              {isAlreadyValidated
                ? 'Clique no botão acima para revalidar este formulário.'
                : 'Clique no botão acima para validar este formulário.'}
            </Text>
          </View>
        </View>
      );
    }

    // Comportamento normal (não validação)
    return (
      <View style={styles.finalActions}>
        <Button
          mode="contained"
          onPress={responseStats.isComplete ? saveCompleteResponse : savePartialProgress}
          icon={responseStats.isComplete ? 'check-circle' : 'content-save'}
          style={[styles.saveButton, responseStats.isComplete && styles.completeButton]}
          buttonColor={
            responseStats.isComplete ? AVAQualisTheme.colors.success : AVAQualisTheme.colors.primary
          }
          textColor={AVAQualisTheme.colors.onPrimary}
          disabled={responseStats.answeredCount === 0 || isSaving}
          loading={isSaving}
        >
          {responseStats.isComplete
            ? `🎉 Parabéns! 100% Completo - Fazer Upload (${allQuestions.length}/${allQuestions.length})`
            : `💾 Salvar Progresso (${responseStats.answeredCount}/${allQuestions.length})`}
        </Button>

        {!responseStats.isComplete && (
          <View style={styles.finalizationWarning}>
            <Text style={styles.finalizationWarningText}>
              ⚠️ Continue respondendo para completar o formulário.
            </Text>
            <Text style={styles.finalizationWarningSubtext}>
              Faltam {allQuestions.length - responseStats.answeredCount} resposta(s). Você pode
              salvar o progresso a qualquer momento.
            </Text>
          </View>
        )}

        {responseStats.isComplete && (
          <View
            style={[styles.finalizationWarning, { borderLeftColor: AVAQualisTheme.colors.success }]}
          >
            <Text
              style={[styles.finalizationWarningText, { color: AVAQualisTheme.colors.success }]}
            >
              ✅ Formulário 100% completo!
            </Text>
            <Text style={styles.finalizationWarningSubtext}>
              Todas as {allQuestions.length} perguntas foram respondidas. Clique no botão acima para
              salvar e preparar para upload.
            </Text>
          </View>
        )}
      </View>
    );
  }, [
    savePartialProgress,
    saveCompleteResponse,
    responseStats,
    allQuestions.length,
    isSaving,
    form,
    currentAvaliador,
  ]);

  // Mostrar tela de carregamento
  if (loadingFormData) {
    return (
      <View style={styles.container}>
        <Appbar.Header style={styles.appbar}>
          <Appbar.BackAction
            onPress={() => {
              console.log('🔙 Voltando durante carregamento');
              if (typeof onBack === 'function') {
                onBack();
              }
            }}
            color={AVAQualisTheme.colors.onPrimary}
          />
          <Appbar.Content title="⏳ Carregando..." titleStyle={styles.appbarTitle} />
        </Appbar.Header>
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color={AVAQualisTheme.colors.primary} />
          <Text style={styles.loadingText}>📋 Carregando formulário...</Text>
        </View>
      </View>
    );
  }

  // Mostrar tela de erro
  if (formLoadError || !formData) {
    return (
      <View style={styles.container}>
        <Appbar.Header style={styles.appbar}>
          <Appbar.BackAction
            onPress={() => {
              console.log('🔙 Voltando por erro de carregamento');
              if (typeof onBack === 'function') {
                onBack();
              }
            }}
            color={AVAQualisTheme.colors.onPrimary}
          />
          <Appbar.Content title="❌ Erro" titleStyle={styles.appbarTitle} />
        </Appbar.Header>
        <View style={styles.loadingContainer}>
          <Text style={styles.loadingText}>❌ Erro ao carregar formulário</Text>
          <Text style={styles.loadingSubtext}>{formLoadError || 'Formulário não encontrado'}</Text>
          <Button mode="contained" onPress={loadFormData} style={{ marginTop: 16 }} icon="refresh">
            🔄 Tentar Novamente
          </Button>
        </View>
      </View>
    );
  }

  // Renderização principal otimizada
  return (
    <View style={styles.container}>
      <Appbar.Header style={styles.appbar}>
        <Appbar.BackAction
          onPress={() => {
            console.log('🔙 Voltando para FormListScreen');
            if (typeof onBack === 'function') {
              onBack();
            } else {
              console.error('❌ onBack não é uma função válida');
            }
          }}
          color={AVAQualisTheme.colors.onPrimary}
        />
        <Appbar.Content
          title={formData.title}
          subtitle={`${responseStats.answeredCount} de ${allQuestions.length} respondidas${form.isCustom ? ' • Customizado' : ''}${hasUnsavedChanges ? ' • 📝 Mudanças não salvas' : ' • ✅ Salvo'}${form.isValidationMode ? ' • 👁️ MODO VALIDAÇÃO' : ''}`}
          titleStyle={styles.appbarTitle}
          subtitleStyle={styles.appbarSubtitle}
        />
        <Appbar.Action
          icon="content-save"
          onPress={savePartialProgress}
          iconColor={AVAQualisTheme.colors.onPrimary}
          disabled={isSaving}
        />
        <Appbar.Action
          icon="delete"
          onPress={resetForm}
          iconColor={AVAQualisTheme.colors.onPrimary}
          disabled={isSaving}
        />
        {currentAvaliador && currentAvaliador.id !== 'visitor' && (
          <Appbar.Action
            icon={streamActive ? 'stop-circle' : 'broadcast'}
            onPress={() => {
              if (streamActive) {
                setStreamDialogType('active');
              } else {
                setStreamDialogType('start');
              }
              setShowStreamDialog(true);
            }}
            iconColor={streamActive ? AVAQualisTheme.colors.error : AVAQualisTheme.colors.onPrimary}
          />
        )}
      </Appbar.Header>

      {/* Header fixo */}
      {fixedHeader}

      {/* ScrollView principal com as perguntas */}
      <ScrollView
        ref={scrollRef}
        style={styles.scrollContainer}
        contentContainerStyle={styles.content}
        showsVerticalScrollIndicator={true}
      >
        {/* Renderizar todas as seções e perguntas */}
        {formData.sections.map((section, sectionIndex) => (
          <View key={section.id} style={styles.sectionContainer}>
            {/* Cabeçalho da Seção */}
            <TouchableOpacity
              onPress={() => toggleSection(section.id)}
              style={styles.sectionHeader}
            >
              <View style={styles.sectionHeaderContent}>
                <View style={styles.sectionInfo}>
                  <Text style={styles.sectionType}>
                    <Text style={styles.sectionLabel}>Tipo de processo:</Text> {section.tipo}
                  </Text>
                  <Text style={styles.sectionCategory}>
                    <Text style={styles.sectionLabel}>Categoria (Função de negócio):</Text>{' '}
                    {section.categoria}
                  </Text>
                  <Text style={styles.sectionSubcategory}>
                    <Text style={styles.sectionLabel}>
                      Subcategoria (Macroprocesso ou processo):
                    </Text>{' '}
                    {section.subcategoria}
                  </Text>
                  <Text style={styles.sectionStats}>
                    {section.questions.length} pergunta(s) •{' '}
                    {section.questions.filter(q => answers[q.id]).length} respondida(s)
                  </Text>
                </View>
                <Text style={styles.sectionToggle}>{expandedSections[section.id] ? '▲' : '▼'}</Text>
              </View>
            </TouchableOpacity>

            {/* Perguntas da Seção */}
            {expandedSections[section.id] && (
              <View style={styles.questionsContainer}>
                {section.questions.map((question, questionIndex) => {
                  const globalQuestionIndex = allQuestions.findIndex(q => q.id === question.id);
                  const isBeingEdited = activeEditingQuestion === question.id;
                  const isFindingSaved = savedFindings[question.id];

                  return (
                    <View
                      key={`question-${question.id}`}
                      ref={ref => {
                        if (ref) {
                          questionRefs.current[globalQuestionIndex] = ref;
                        }
                      }}
                      style={[
                        styles.questionContainer,
                        isBeingEdited && styles.questionContainerEditing,
                      ]}
                    >
                      <Card
                        style={[styles.questionCard, isBeingEdited && styles.questionCardEditing]}
                      >
                        <Card.Content>
                          <View style={styles.questionHeader}>
                            <View style={styles.questionMeta}>
                              <View style={styles.questionCodeContainer}>
                                <Chip mode="outlined" compact style={styles.questionCodeChip}>
                                  📋 {question.codigo}
                                </Chip>
                                {question.isEssential && (
                                  <View style={styles.essentialBadge}>
                                    <Text style={styles.essentialIcon}>⚠️</Text>
                                    <Text style={styles.essentialText}>RE</Text>
                                  </View>
                                )}
                                {isBeingEdited && (
                                  <Chip
                                    mode="flat"
                                    compact
                                    style={styles.editingChip}
                                    textStyle={styles.editingChipText}
                                  >
                                    ✏️ Editando
                                  </Chip>
                                )}
                              </View>
                            </View>
                            {answers[question.id] && (
                              <View style={styles.questionStatus}>
                                <Text style={styles.questionStatusText}>
                                  {getAnswerLabel(answers[question.id])}
                                </Text>
                              </View>
                            )}
                          </View>
                          <Title style={styles.questionTitle}>
                            <Text style={styles.requirementLabel}>REQUISITO:</Text>{' '}
                            {question.question}
                          </Title>
                          {/* Premissa */}
                          <View style={styles.detailsContainer}>
                            <Text style={styles.detailsLabel}>Premissa:</Text>
                            <Text style={styles.detailsText}>{question.premissa}</Text>
                          </View>
                          {/* Fontes */}
                          <View style={styles.detailsContainer}>
                            <Text style={styles.detailsLabel}>
                              Fonte de informações e evidências:
                            </Text>
                            <Text style={styles.detailsText}>{question.fontes}</Text>
                          </View>
                          {/* Segmento */}
                          {question.segmento && question.segmento.trim() && (
                            <View style={styles.detailsContainer}>
                              <Text style={styles.detailsLabel}>🎯 Segmento:</Text>
                              <Text style={styles.detailsText}>{question.segmento}</Text>
                            </View>
                          )}

                          {/* ✅✅✅ SUGESTÃO DE ROTEIRO - FORÇAR RENDERIZAÇÃO */}
                          {question.sugestaoRoteiro && question.sugestaoRoteiro.trim() && (
                            <View
                              style={[
                                styles.detailsContainer,
                                {
                                  marginTop: 12,
                                  backgroundColor: '#E3F2FD',
                                  padding: 10, // ✅ Reduzido de 12 para 10
                                  borderRadius: 8,
                                  borderLeftWidth: 4,
                                  borderLeftColor: '#2196F3',
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.detailsLabel,
                                  {
                                    color: '#0D47A1',
                                    fontSize: 13, // ✅ Reduzido de 16 para 13
                                    fontWeight: 'bold',
                                  },
                                ]}
                              >
                                💡 Sugestão de Roteiro:
                              </Text>
                              <Text
                                style={[
                                  styles.detailsText,
                                  {
                                    fontStyle: 'italic',
                                    color: '#1565C0',
                                    lineHeight: 18, // ✅ Reduzido de 22 para 18
                                    marginTop: 6, // ✅ Reduzido de 8 para 6
                                    fontSize: 12, // ✅ Fonte menor: 12px
                                  },
                                ]}
                              >
                                {question.sugestaoRoteiro}
                              </Text>
                            </View>
                          )}

                          {/* Opções de Resposta */}
                          <View style={styles.optionsContainer}>
                            {[
                              { value: 'conforme', label: '✅ Conforme', emoji: '✅' },
                              { value: 'nao-conforme', label: '❌ Não Conforme', emoji: '❌' },
                              { value: 'nao-se-aplica', label: '➖ Não se Aplica', emoji: '➖' },
                            ].map((option, optionIndex) => (
                              <View
                                key={optionIndex}
                                style={[
                                  styles.radioOption,
                                  answers[question.id] === option.value &&
                                    styles.radioOptionSelected,
                                ]}
                              >
                                <RadioButton
                                  value={option.value}
                                  status={
                                    answers[question.id] === option.value ? 'checked' : 'unchecked'
                                  }
                                  onPress={() => handleAnswer(question.id, option.value)}
                                  color={AVAQualisTheme.colors.primary}
                                />
                                <Text
                                  style={styles.radioLabel}
                                  onPress={() => handleAnswer(question.id, option.value)}
                                >
                                  {option.label}
                                </Text>
                              </View>
                            ))}
                          </View>
                          {/* Justificativa para Não se Aplica */}
                          {answers[question.id] === 'nao-se-aplica' &&
                            notApplicableReasons[question.id] && (
                              <View style={styles.notApplicableReasonContainer}>
                                <Text style={styles.notApplicableReasonLabel}>
                                  Justificativa para "Não se Aplica":
                                </Text>
                                <Text style={styles.notApplicableReasonText}>
                                  {notApplicableReasons[question.id]}
                                </Text>
                              </View>
                            )}
                          {/* Campo de Registro dos Achados */}
                          {answers[question.id] &&
                            answers[question.id] !== 'nao-se-aplica' &&
                            !isFindingSaved && (
                              <View style={styles.findingsContainer}>
                                <Text style={styles.findingsLabel}>📝 Registro dos Achados *</Text>

                                <TextInput
                                  mode="outlined"
                                  multiline
                                  numberOfLines={4}
                                  placeholder="Descreva os achados, evidências encontradas, observações relevantes..."
                                  placeholderTextColor={styles.placeholderText.color}
                                  value={findings[question.id] || ''}
                                  onChangeText={text => handleFindingChange(question.id, text)}
                                  style={styles.findingsInput}
                                  outlineColor={AVAQualisTheme.colors.outline}
                                  activeOutlineColor={AVAQualisTheme.colors.primary}
                                  editable={
                                    !activeEditingQuestion || activeEditingQuestion === question.id
                                  }
                                />
                                <Button
                                  mode="contained"
                                  onPress={() => saveFinding(question.id)}
                                  icon="content-save"
                                  style={styles.saveFindingButton}
                                  buttonColor={AVAQualisTheme.colors.success}
                                  disabled={
                                    !findings[question.id] ||
                                    findings[question.id].trim().length < 3
                                  }
                                >
                                  💾 Salvar Achado
                                </Button>
                              </View>
                            )}
                          {/* Mostrar achados salvos */}
                          {answers[question.id] &&
                            answers[question.id] !== 'nao-se-aplica' &&
                            isFindingSaved && (
                              <View style={styles.savedFindingContainer}>
                                <Text style={styles.savedFindingLabel}>
                                  📝 Achados Registrados:
                                </Text>
                                <Text style={styles.savedFindingText}>{findings[question.id]}</Text>
                                <Button
                                  mode="outlined"
                                  onPress={() => editFinding(question.id)}
                                  icon="pencil"
                                  style={styles.editFindingButton}
                                  textColor={AVAQualisTheme.colors.primary}
                                  compact
                                >
                                  ✏️ Editar Achados
                                </Button>
                              </View>
                            )}
                          {/* Componente de Anexos */}
                          {answers[question.id] && (
                            <AttachmentComponent
                              questionId={question.id}
                              questionCode={question.codigo}
                              attachments={attachments[question.id] || []}
                              onAttachmentsChange={newAttachments =>
                                handleAttachmentsChange(question.id, newAttachments)
                              }
                              disabled={
                                activeEditingQuestion && activeEditingQuestion !== question.id
                              }
                              onViewAttachment={handleViewAttachment}
                              localFileData={attachmentLocalData}
                              onLocalDataChange={(attachmentId, data) => {
                                setAttachmentLocalData(prev => ({
                                  ...prev,
                                  [attachmentId]: data,
                                }));
                              }}
                            />
                          )}
                          {/* Preview da Resposta */}
                          {answers[question.id] && (
                            <View style={styles.answerPreview}>
                              <Text style={styles.answerPreviewLabel}>✅ Sua resposta:</Text>
                              <Text style={styles.answerPreviewText}>
                                {getAnswerLabel(answers[question.id])}
                              </Text>
                            </View>
                          )}
                        </Card.Content>
                      </Card>
                    </View>
                  );
                })}
              </View>
            )}
          </View>
        ))}

        {/* Ações finais */}
        {finalActionButtons}

        {/* Resumo das respostas */}
        {responseStats.answeredCount > 0 && (
          <Card style={styles.summaryCard}>
            <Card.Content>
              <View style={styles.summaryHeader}>
                <Title style={styles.summaryTitle}>📋 Resumo das Respostas</Title>
                <Badge style={styles.summaryBadge}>{responseStats.answeredCount}</Badge>
              </View>

              <ScrollView style={styles.summaryScroll} nestedScrollEnabled>
                {allQuestions.map((q, index) => {
                  const answer = answers[q.id];
                  if (!answer) return null;

                  const questionAttachments = attachments[q.id] || [];

                  return (
                    <View key={q.id} style={styles.summaryItem}>
                      <View style={styles.summaryItemHeader}>
                        <Text style={styles.summaryQuestion}>
                          {q.codigo}. {q.question}
                        </Text>
                        <IconButton
                          icon="pencil"
                          size={16}
                          onPress={() => scrollToQuestion(index)}
                          iconColor={AVAQualisTheme.colors.primary}
                          style={styles.editIconButton}
                        />
                      </View>
                      <Text style={styles.summaryAnswer}>{getAnswerLabel(answer)}</Text>
                      {notApplicableReasons[q.id] && (
                        <Text style={styles.summaryNotApplicableReason}>
                          Justificativa: {notApplicableReasons[q.id]}
                        </Text>
                      )}
                      {findings[q.id] && (
                        <Text style={styles.summaryFinding}>Achados: {findings[q.id]}</Text>
                      )}
                      {questionAttachments.length > 0 && (
                        <View style={styles.attachmentPreviewCompact}>
                          <Text style={styles.attachmentPreviewTitleCompact}>
                            📎 {questionAttachments.length} anexo(s)
                          </Text>
                          {questionAttachments.map((attachment, index) => (
                            <TouchableOpacity
                              key={attachment.id || index}
                              style={styles.attachmentItemCompact}
                              onPress={() => handleViewAttachment(attachment)}
                            >
                              <Text style={styles.attachmentItemNameCompact} numberOfLines={1}>
                                {getFileEmoji(attachment.mimeType, attachment.name)}{' '}
                                {attachment.name || attachment.url || 'Anexo'}
                              </Text>
                            </TouchableOpacity>
                          ))}
                        </View>
                      )}
                    </View>
                  );
                })}
              </ScrollView>
            </Card.Content>
          </Card>
        )}

        <View style={styles.bottomSpacer} />
      </ScrollView>

      {/* Custom Dialog Component */}
      <CustomDialog
        visible={dialogVisible}
        onDismiss={() => setDialogVisible(false)}
        title={dialogContent.title}
        message={dialogContent.message}
        actions={dialogContent.actions}
      />

      {/* Dialog para "Não se Aplica" */}
      <CustomDialog
        visible={notApplicableDialogVisible}
        onDismiss={() => {
          setNotApplicableDialogVisible(false);
          setTempNotApplicableText('');
          setActiveEditingQuestion(null);
        }}
        title="➖ Justificar 'Não se Aplica'"
        actions={[
          {
            text: 'Cancelar',
            action: () => {
              setNotApplicableDialogVisible(false);
              setTempNotApplicableText('');
              setActiveEditingQuestion(null);
            },
          },
          {
            text: 'Salvar',
            action: handleNotApplicableSubmit,
          },
        ]}
      >
        <View>
          <Text style={styles.dialogMessage}>
            Por favor, explique por que esta pergunta não se aplica ao seu contexto:
          </Text>
          <TextInput
            mode="outlined"
            multiline
            numberOfLines={4}
            placeholder="Justifique o Não Se Aplica..."
            placeholderTextColor={styles.placeholderText.color}
            value={tempNotApplicableText}
            onChangeText={setTempNotApplicableText}
            style={styles.notApplicableInput}
            outlineColor={AVAQualisTheme.colors.outline}
            activeOutlineColor={AVAQualisTheme.colors.primary}
          />
          <Text style={styles.characterCount}>
            Caracteres digitados: {tempNotApplicableText.length} (mínimo 3)
          </Text>
        </View>
      </CustomDialog>

      {/* Dialog do Stream */}
      <CustomDialog
        visible={showStreamDialog}
        onDismiss={() => setShowStreamDialog(false)}
        title={streamDialogType === 'start' ? '🎥 Iniciar Stream' : '🎥 Stream Ativo'}
        actions={
          streamDialogType === 'start'
            ? [
                { text: 'Cancelar', action: () => setShowStreamDialog(false) },
                { text: 'Iniciar Stream', action: startStream },
              ]
            : [
                { text: 'Fechar', action: () => setShowStreamDialog(false) },
                {
                  text: 'Compartilhar Link',
                  action: () => {
                    setShowStreamDialog(false);
                    shareStreamLink();
                  },
                },
                { text: '🛑 Parar Stream', action: stopStream },
              ]
        }
      >
        {streamDialogType === 'start' ? (
          <View>
            <Text style={styles.dialogMessage}>
              O stream permite que outras pessoas acompanhem sua avaliação em tempo real.
            </Text>

            <View
              style={{
                marginTop: 16,
                padding: 12,
                backgroundColor: `${AVAQualisTheme.colors.warning}20`,
                borderRadius: 8,
                borderLeftWidth: 3,
                borderLeftColor: AVAQualisTheme.colors.warning,
              }}
            >
              <Text style={{ fontWeight: 'bold', marginBottom: 8 }}>
                ⚠️ Requisitos Importantes:
              </Text>
              <Text style={{ marginBottom: 4 }}>• Conexão estável com a internet</Text>
              <Text style={{ marginBottom: 4 }}>• Apenas a questão em edição será transmitida</Text>
              <Text style={{ marginBottom: 4 }}>• O link expira em 24 horas</Text>
              <Text>• Dados consolidados não são mostrados</Text>
            </View>

            <Text style={{ marginTop: 16, fontStyle: 'italic' }}>
              💡 Dica: Compartilhe o link com a área avaliada para que possam acompanhar em uma TV
              ou computador.
            </Text>
          </View>
        ) : (
          <View>
            <Text style={styles.dialogMessage}>Stream ativo e transmitindo!</Text>

            <View
              style={{
                marginTop: 16,
                padding: 12,
                backgroundColor: `${AVAQualisTheme.colors.success}10`,
                borderRadius: 8,
                borderWidth: 1,
                borderColor: AVAQualisTheme.colors.success,
              }}
            >
              <Text style={{ fontWeight: 'bold', marginBottom: 8 }}>🔗 Link do Stream:</Text>
              <TouchableOpacity onPress={() => Clipboard.setString(streamLink)}>
                <Text
                  style={{
                    color: AVAQualisTheme.colors.primary,
                    textDecorationLine: 'underline',
                    fontSize: 18, // Maior para facilitar leitura
                    textAlign: 'center',
                    marginVertical: 8,
                  }}
                >
                  {streamLink}
                </Text>
              </TouchableOpacity>
              {/* Mostrar apenas o código para facilitar */}
              <Text
                style={{
                  fontSize: 32,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  color: AVAQualisTheme.colors.primary,
                  marginTop: 16,
                  fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace',
                }}
              >
                Código: {streamId}
              </Text>

              <Text
                style={{
                  textAlign: 'center',
                  marginTop: 8,
                  fontStyle: 'italic',
                }}
              >
                Digite no navegador: avaqualis.com/stream/{streamId}
              </Text>
            </View>

            <Text style={{ marginTop: 16, textAlign: 'center' }}>
              📺 Compartilhe este link com a área avaliada
            </Text>

            {Platform.OS === 'web' && (
              <Button
                mode="contained"
                onPress={() => {
                  window.open(streamLink, '_blank');
                }}
                style={{ marginTop: 16 }}
                icon="open-in-new"
              >
                Abrir em Nova Aba
              </Button>
            )}
          </View>
        )}
      </CustomDialog>

      {/* Dialog de Salvamento em Progresso */}
      <CustomDialog
        visible={savingProgressDialog}
        onDismiss={() => {}} // Não permitir fechar clicando fora
        title="💾 Salvando Progresso..."
        actions={[]} // Sem ações - não dá pra fechar
      >
        <View style={{ alignItems: 'center', padding: 20 }}>
          <ActivityIndicator
            size="large"
            color={AVAQualisTheme.colors.primary}
            style={{ marginBottom: 20 }}
          />

          <Text style={[styles.dialogMessage, { textAlign: 'center', marginBottom: 10 }]}>
            🔄 Salvando localmente e enviando para a nuvem...
          </Text>

          <Text
            style={{
              fontSize: 32,
              fontWeight: 'bold',
              color: AVAQualisTheme.colors.primary,
              marginVertical: 10,
            }}
          >
            {savingCountdown}s
          </Text>

          <Text
            style={{
              fontSize: 12,
              color: AVAQualisTheme.colors.secondary,
              textAlign: 'center',
              fontStyle: 'italic',
            }}
          >
            {savingCountdown > 0
              ? 'Aguarde enquanto salvamos seu progresso...'
              : 'Finalizando... Se demorar muito, clique em "Salvar" novamente.'}
          </Text>
        </View>
      </CustomDialog>
    </View>
  );
}
